<template>
  <div style="z-index: 200; position: relative;">
    <v-form v-model="valid">
      <block v-if="loading"></block>
      <v-row class="mt-0">
        <v-col cols="12">
          <div class="shadow row ma-0 py-4 box pl-4 pr-4">
            <v-row class="mt-5">
              <v-col cols="12">
                <v-row>
                  <v-col cols="12" v-if="this.orderDetails != null">
                    <v-alert type="warning"
                      >Orden de compra sin procesar.</v-alert
                    >
                  </v-col>
                  <v-col cols="12" md="4">
                    <date-picker
                      label="Fecha de Orden de Compra"
                      v-model="purchaseorderdate"
                      @dateSelected="(param) => (purchaseorderdate = param)"
                    ></date-picker>
                  </v-col>

                  <!--v-col cols="6" md="3">
                    <v-text-field
                      outlined
                      dense
                      v-model="orderid"
                      label="Número de Orden de Compra"
                      :readonly="readonly"
                    ></v-text-field>
                  </v-col-->

                  <v-col cols="12" md="4">
                    <v-text-field
                      outlined
                      dense
                      v-model="this.data.ID_Provider"
                      label="ID del Proveedor"
                      :readonly="readonly"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                   
                      outlined
                      dense
                      v-model="this.data.ProviderName"
                      label="Nombre del Proveedor"
                      :readonly="readonly"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <CustomCSVPeriod @customCSVPeriod="setCustomCSVPeriod" @year="setCustomCSVPeriodYear" @month="setCustomCSVPeriodMonth" :cleanState="cleanState" @resetCleanState="() => cleanState = false" :submitState="submitCustomCSVPeriodState" />
              </v-col>

              <v-col cols="12" sm="6" >
                <div
                  :class="showBgcolorNotes"
                  @click="showComment = !showComment"
                  style="margin-bottom: 10px"
                >
                  <center>Notas internas de la orden de compra</center>
                </div>
              </v-col>

              <v-col cols="12" sm="6"  >
                <h3 
                  class="tabs"
                  style="text-align: center;margin-bottom: 10px"
                  @click="setShowInfoPurchaseDialog(showInfoPurchase = !showInfoPurchase)"
                >
                  Datos de la factura del proveedor
                </h3>
              </v-col>

              <v-dialog v-model="showComment" scrollable max-width="1000">
                <v-card height="inherit">
                  <v-card-title class="text-h5"
                    >Notas internas de la orden de compra</v-card-title
                  >
                  <v-card-text>
                    <quill-editor
                      :content="header.purchaseorderinternalnote"
                      @change="onEditorChange($event)"
                    ></quill-editor>
                  </v-card-text>
                  <v-card-actions>
                    <v-col class="text-right">
                      <v-btn
                        @click="showComment = !showComment"
                        class="btndisable"
                      >
                        Continuar
                      </v-btn>
                    </v-col>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="showInfoPurchase" max-width="1000" :z-index="1200" content-class="purchase-info-dialog">
                <v-card height="inherit">
                  <v-card-title class="text-h5"
                    >Datos de la factura</v-card-title
                  >
                  <v-card-text>
                    <v-row class="mt-6 ml-2 mr-2 mb-6">
                      <v-col cols="12" md="3">
                        <center>
                          <v-img
                            :src="url"
                            width="100px"
                            height="100px"
                            class="preview-avatar"
                          ></v-img>
                        </center>
                        <v-file-input
                          @change="Preview_image"
                          v-model="image"
                          label="Imágen de Factura"
                          prepend-icon="mdi-camera"
                          placeholder="Imágen de Factura"
                          :rules="[maxFileSize]"
                        >
                        </v-file-input>
                      </v-col>

                      <v-col cols="12" md="9">
                        <v-row>
                          <v-col cols="12" md="6">
                            <date-picker
                              ref="inputdatepicker"
                              label="Fecha de la Factura"
                              v-model="purchaseinvoicedate"
                              @dateSelected="
                                (param) => (purchaseinvoicedate = param)
                              "
                            ></date-picker>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              outlined
                              dense
                              :items="catalogTypedocument"
                              attach
                              label="Tipo de Factura"
                              v-model="header.purchaseordertype"
                              @change="addValidToTypeInvoice(true)"
                              required
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              outlined
                              dense
                              v-model="header.documenttype"
                              :items="documentOptions"
                              :items-value="value"
                              :items-text="text"
                              attach
                              label="Tipo de documento"
                              :disabled="header.purchaseordertype == 'FNS'"
                              required
                            ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              outlined
                              dense
                              v-model="header.purchaselegalinvoicenumber"
                              :label="
                                header.documenttype == '2'
                                  ? 'Código de generación'
                                  : 'Correlativo factura'
                              "
                              v-if="header.purchaseordertype != 'FNS'"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-if="header.purchaseordertype == 'NC' || header.NumeroDocumentoRelacionado">
                          <v-col cols="12">
                            <v-text-field
                              outlined
                              dense
                              v-model="header.NumeroDocumentoRelacionado"
                              label="Codigo de generación Documento Relacionado"
                              hint="Codigo de generación al que hace referencia esta nota de crédito"
                              persistent-hint
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-if="header.documenttype == '2' && header.purchaseordertype != 'FNS'">
                          <v-col cols="12" md="6">
                            <v-text-field
                              outlined
                              dense
                              v-model="header.numerocontrol"
                              label="Número de control"
                              placeholder="DTE-01-M001P001-000000000000013"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              outlined
                              dense
                              v-model="header.selloRecibido"
                              label="Sello Recibido"
                              placeholder="Sello de validación del MH"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-autocomplete
                              outlined
                              dense
                              v-model="header.paymentMethod"
                              :items="paymentTypes"
                              item-text="Valores"
                              attach
                              label="Método de Pago"
                              required
                            ></v-autocomplete>
                          </v-col>

                          <v-col cols="12" md="6">
                            <v-autocomplete
                              outlined
                              dense
                              v-model="header.invoiceStatus"
                              :items="invoiceStatus"
                              label="Estado de la Factura"
                              attach
                              required
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6"
                            v-if="header.invoiceStatus == 'Crédito'"
                          >
                            <v-autocomplete
                              outlined
                              dense
                              v-model="header.days"
                              :items="days"
                              attach
                              label="Plazo"
                            >
                            </v-autocomplete>
                          </v-col>

                          <v-col
                            cols="12"
                            md="6"
                            v-if="
                              header.paymentMethod != 'Billetes y monedas' &&
                              header.paymentMethod != undefined
                            "
                          >
                            <v-text-field
                              outlined
                              dense
                              v-model="header.nreference"
                              label="N. Referencia"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <!-- Clasificación para anexos -->
                    <v-row class="mt-6 ml-2 mr-2">
                      <v-col cols="12">
                        <v-card outlined class="pa-4">
                          <h3 class="mb-6">Clasificación para anexos</h3>
                          <v-row>
                            <v-col cols="12" md="4">
                              <ClasificationRentaAutocomplete 
                                v-model="header.ClasificationRent" 
                                required
                              />
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-select
                                outlined
                                dense
                                v-model="header.SectorProveedores"
                                :items="sectorProveedores"
                                item-text="Valores"
                                item-value="Codigo"
                                attach
                                clearable
                                label="Sector"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-select
                                outlined
                                dense
                                v-model="header.TipoIngresoProveedores"
                                :items="tipoIngresoProveedores"
                                item-text="Valores"
                                item-value="Codigo"
                                attach
                                clearable
                                label="Tipo de Costo / Gasto"
                              ></v-select>
                            </v-col>
                            <v-col>
                              <small>Los campos <b>Tipo de Costo / Gasto</b> y <b>Sector</b> son opcionales; si no se seleccionan, se tomarán los valores predeterminados del proveedor.</small>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-col class="text-right">
                      <v-btn
                        @click="() => {
                          showInfoPurchase = !showInfoPurchase
                          if(this.productsToLoad.length) this.showJsonLoading = true
                        }"
                        class="btndisable"
                      >
                        Continuar
                      </v-btn>
                    </v-col>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row class="mb-10">
        <v-dialog v-model="showProducts" max-width="1000">
          <v-card>
            <v-card-title class="text-h5">Productos y servicios disponibles</v-card-title>
            <v-card-text>
              <v-row class="mt-2">
                <div style="display: flex; margin-left: 5px">
                  <input
                    type="radio"
                    id="InvoiceProductBtn"
                    value="products"
                    v-model="displayInvoice"
                  />
                  <h5 style="margin: 5px" for="InvoiceProductBtn">Productos</h5>
                  <input
                    style="margin-top: 1px; margin-left: 10px"
                    type="radio"
                    id="InvoiceServiceBtn"
                    value="services"
                    v-model="displayInvoice"
                  />
                  <h5 style="margin: 5px" for="InvoiceServiceBtn">Servicios</h5>
                </div>
              </v-row>
              
              <v-row>
                <template v-if="displayInvoice == 'products'">
                  <v-col cols="12">
                    <!-- only for "MANUEL ENRIQUE PINEDA MARTINEZ", "RECINOS BOLAINES, GUADALUPE" d76ca00b6f45acf9815bc10e1d9b7652 -->
                    <template v-if="noProvider">
                      <v-alert type="info" text>
                        Busque producto por código o nombre y presiona el botón
                        <v-icon color="black">mdi-magnify</v-icon>
                      </v-alert>
                    </template>
                  </v-col>
                  <v-col cols="12">
                    <GeneralFilter
                      entity="lista"
                      :filterEndpoint="
                        $API.products.getProductsToBillForPurchaseOrdersFiltered
                      "
                      :search="search"
                      @emptyFilter="getProducts"
                      @filtered="filterHandlerProducts"
                      @loading="(v) => loadingProducts = v"
                      :isAutoScrolled="true"
                    >
                      <div style="position:absolute; margin-top: -40px;" v-if="loadingProducts">
                        <v-progress-circular
                        indeterminate
                        size="24"
                        width="3"
                        ></v-progress-circular> 
                        <span class="mx-2">
                          Buscando...
                        </span>
                      </div>
                      <DxDataGrid
                        :data-source="productsToBill"
                        :allow-column-resizing="true"
                        :column-auto-width="true"
                        key-expr="ID_Item"
                        :paging="{ enabled: false }"
                        :scrolling="{ useNative: true }"
                        style="max-height: 250px;"
                      >
                        <DxScrolling mode="virtual"/>
                        <DxColumn
                          :width="50"
                          cell-template="show-template"
                          caption=""
                        ></DxColumn>
                        <!--DxPaging :page-size="5" /-->
                        <DxColumn data-field="ID_Item" caption="ID" width="125px">
                        </DxColumn>
                        <DxColumn data-field="BarCode" caption="Código Alterno" width="125px">
                        </DxColumn>
                        <DxColumn
                          data-field="ItemName"
                          caption="Nombre de Producto"
                        ></DxColumn>
                        <!--DxColumn data-field="Warehouse" caption="Almacén"></DxColumn-->
                        <!--DxColumn data-field="ItemLote" caption="Lote"></DxColumn-->
                        <DxColumn
                          :width="225"
                          data-field="AverageCost"
                          :calculate-display-value="(rowData => rowData.AverageCost.toFixed(4))"
                          caption="último costo de compra"
                        ></DxColumn>
                        <DxColumn
                          :width="225"
                          data-field="ItemPrice"
                          :calculate-display-value="(rowData => rowData.ItemPrice ? rowData.ItemPrice.toFixed(2) : 0)"
                          caption="Precio de Venta"
                        ></DxColumn>
                        

                        <template #show-template="{ data }">
                          <a
                            href="#"
                            class="mx-1"
                            @click.prevent.stop="setNewItem(data.data)"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </a>
                        </template>
                      </DxDataGrid>
                    </GeneralFilter>
                  </v-col>
                </template>  

                <template v-if="displayInvoice == 'services'">
                  <v-col cols="12">
                    <GeneralFilter
                      :filterEndpoint="$API.services.getAllServicesFiltered"
                      :search="search"
                      @emptyFilter="getAllServices"
                      @filtered="filterHandlerServices"
                    >
                      <DxDataGrid
                        class="isScrolledByGeneralFilter"
                        :data-source="servicesToBill"
                        key-expr="CodeService"
                        :paging="{ enabled: false }"
                        style="max-height: 250px;"
                      >
                        <DxScrolling row-rendering-mode="virtual" />
                        <!--DxPaging :page-size="5" /-->
                        <DxColumn
                          :width="45"
                          cell-template="show-template"
                          caption=""
                        ></DxColumn>
                        <template #show-template="{ data }">
                          <a href="#" class="mx-1" @click.prevent.stop="setNewItem(data.data)">
                            <v-icon>mdi-plus</v-icon>
                          </a>
                        </template>
                        <DxColumn
                          :width="150"
                          data-field="CodeService"
                          caption="ID"
                        ></DxColumn>
                        <DxColumn
                          data-field="NameService"
                          header-cell-template="headerNameService"
                        ></DxColumn>
                        <template #headerNameService="{}">
                          <div>Nombre de<br />servicio</div>
                        </template>
                        <DxColumn
                          data-field="Name"
                          header-cell-template="headerNameLab"
                        ></DxColumn>
                        <template #headerNameLab="{}">
                          <div>Nombre a<br />facturar</div>
                        </template>
                        <DxColumn
                          :width="130"
                          data-field="TypeService"
                          header-cell-template="headerTypeservice"
                        >
                          <DxLookup
                            :data-source="typeService"
                            display-expr="Name"
                            value-expr="ID"
                          />
                        </DxColumn>
                        <template #headerTypeservice="{}">
                          <div>Tipo de<br />servicio</div>
                        </template>
                        <DxColumn
                          :width="120"
                          cell-template="itemPriceFormatted"
                          caption="Precio"
                        ></DxColumn>
                        <template #itemPriceFormatted="{ data }">
                          {{ this.header.itemcurrency
                          }}{{ numberWithCommas(data.data.Price) }}
                        </template>
                      </DxDataGrid>
                    </GeneralFilter>
                  </v-col>
                </template>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-col class="text-right">
                <v-btn @click="showProducts = !showProducts" class="btndisable">
                  Continuar
                </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <Dialog
          v-if="!!newItem"
          :show="!!newItem"
          @close="newItem = null;"
          max-width="600px"
        >
          <template #title>
            <div class="d-none d-md-block" style="color: #37474F">
              <div class="mr-2" style="color: #37474F">Agregar producto o servicio:</div>
            </div>
            <div class="d-md-none" style="font-size: 1rem;">
              <div class="mr-2" style="color: #37474F">Agregar producto o servicio:</div>
            </div>
          </template>

          <template #body>
            <div  
              style="
                font-size: 1.25rem; 
                color: #263238; 
                font-weight: bold;
                margin: 1.5rem 0;
              "
            >
              {{ newItem.ItemName }}
            </div>
            <v-row class="mt-5">
              <!-- Quantity -->
              <v-col cols="12" :sm="displayInvoice == 'products' ? 4 : 6">
                <v-text-field
                  ref="newItemQty"
                  v-model="newItem.qty"
                  label="Cantidad"
                  type="number"
                  outlined
                  dense
                  @focus="$event.target.select()"
                  @keydown.enter.prevent="addNewItem"
                />
              </v-col>
              <!-- Unit price -->
              <v-col cols="12" :sm="displayInvoice == 'products' ? 4 : 6">
                <v-text-field
                  v-model="newItem.ItemNewPrice"
                  label="Costo unitario"
                  type="number"
                  outlined
                  dense
                  @focus="$event.target.select()"
                  @keydown.enter.prevent="addNewItem"
                />
              </v-col>
              <!-- Batch -->
              <v-col v-if="displayInvoice == 'products'" cols="12" sm="4">
                <v-text-field
                  v-model="newItem.ID_ItemBatch"
                  label="lote"
                  maxlength="20"
                  outlined
                  dense
                  @focus="$event.target.select()"
                  @keydown.enter.prevent="addNewItem"
                />
              </v-col>
            </v-row>
          </template>

          <template #footer-actions>
            <Button
              class="mr-2"
              color="success" 
              @click="addNewItem"
              prepend-icon="mdi-plus"
            >
              Agregar
            </Button>
          </template>
        </Dialog>

        <v-dialog v-model="showJsonImport" max-width="500">
          <v-card class="py-5">
            <v-card-title class="mb-3 font-weight-bold text-nowrap"
              >Importar archivo tipo JSON</v-card-title
            >
            <v-card-actions>
              <v-row>
                <v-col cols="12" class="d-flex flex-row flex-wrap">
                  <v-file-input
                    style="min-width: 200px"
                    outlined
                    dense
                    @change="handleFileUpload"
                    accept="application/json"
                    label="Seleccione un JSON"
                    class="mr-3"
                    :rules="[maxFileSize]"
                  >
                  </v-file-input>
                  <v-btn @click="importJsonData" class="btn-save">
                    <v-icon class="mr-2">mdi-import</v-icon> Importar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOGS PROCESAMIENTO DE ARCHIVO JSON -->
        <v-dialog v-model="showJsonImport2" max-width="500">
          <v-card class="py-5">
            <v-card-title class="mb-3 font-weight-bold text-nowrap"
              >Importar archivo tipo JSON</v-card-title
            >
            <v-card-actions>
              <v-row>
                <v-col cols="12" class="d-flex flex-row flex-wrap">
                  <v-file-input
                    style="min-width: 200px"
                    outlined
                    dense
                    ref="fileInput"
                    @change="handleFileChange"
                    accept="application/json"
                    label="Seleccione un JSON"
                    class="mr-3"
                    :value="this.selectedFile"
                    :rules="[maxFileSize]"
                  >
                  </v-file-input>
                  <v-btn @click="processJsonData" class="btn-save">
                    <v-icon class="mr-2">mdi-import</v-icon> Importar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <PurchaseDetailImport
          v-model="showExcelImport"
          :provider-id="data.ID_Provider"
          :no-provider="noProvider"
          :invoice-type="header.purchaseordertype"
          :invoice-type-options="catalogTypedocument"
          :bar-codes="barCodes"
          :inventory-items="allProvidersInventoryItems"
          :disabled="disableButtons"
          @invoice-type-change="handleExcelInvoiceTypeChange"
          @import-detail="handleDetailImport"
          @show-alert="handleAlertFromComponent"
        />

        <!-- Nuevo componente de gestión de productos JSON -->
        <JsonProductManager
          v-model="showJsonLoading"
          :products-data="productsToLoad"
          :processing="jsonProcessing"
          :provider-info="currentImportSource === 'excel' ? { nombreComercial: data.ProviderName, nit: data.ProviderLegalNIT } : jsonData?.emisor"
          :provider-nit="data.ProviderLegalNIT"
          :provider-id="data.ID_Provider"
          :no-provider="noProvider"
          :all-providers-inventory-items="allProvidersInventoryItems"
          @close="clearJsonData"
          @product-linked="onProductLinked"
          @product-updated="onProductUpdated"
          @load-products="onLoadProducts"
          @show-alert="handleAlertFromComponent"
          @create-products="onCreateProducts"
          @create-product="openProductCreationDialog"
        />
        
        <!-- Modal de conversión de cantidad -->
        <v-dialog v-model="showQuantityConversion" max-width="600px" persistent>
          <v-card>
            <v-card-title class="text-h6" style="background-color: #1976d2; color: white;">
              <v-icon color="white" class="mr-2">mdi-calculator</v-icon>
              Conversión de unidades
            </v-card-title>
            <v-card-text class="pt-6">
              <v-row>
                <v-col cols="12">
                  <div class="mb-4">
                    <strong>Producto:</strong> {{ conversionData.productCode }} - {{ conversionData.productDescription }}
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="conversionData.packQuantity"
                    label="Cantidad de Paquetes/Cajas"
                    type="number"
                    outlined
                    dense
                    @input="calculateConversion"
                    :rules="[(v) => v > 0 || 'Debe ser mayor a 0']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="conversionData.conversionFactor"
                    label="Unidades por Paquete/Caja"
                    type="number"
                    outlined
                    dense
                    @input="calculateConversion"
                    :rules="[(v) => v > 0 || 'Debe ser mayor a 0']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="conversionData.pricePerPack"
                    label="Precio por Paquete/Caja"
                    type="number"
                    outlined
                    dense
                    prefix="$"
                    @input="calculateConversion"
                    :rules="[(v) => v > 0 || 'Debe ser mayor a 0']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="mb-4">
                    <strong>Nuevos valores</strong>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="conversionData.totalQuantity"
                    label="Total de Unidades"
                    outlined
                    dense
                    readonly
                    hide-details
                    :value="conversionData.totalQuantity.toFixed(4)"
                    style="background-color: #f5f5f5;"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>mdi-package-variant</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="conversionData.unitPrice"
                    label="Precio Unitario"
                    outlined
                    dense
                    readonly
                    hide-details
                    :value="'$' + conversionData.unitPrice.toFixed(4)"
                    style="background-color: #f5f5f5;"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>mdi-currency-usd</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="conversionData.totalPrice"
                    label="Precio Total"
                    outlined
                    dense
                    readonly
                    hide-details
                    :value="'$' + conversionData.totalPrice.toFixed(4)"
                    style="background-color: #f5f5f5;"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>mdi-cash-multiple</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" style="display: none;">
                  <v-alert
                    type="info"
                    dense
                    outlined
                    class="mb-0 mt-2"
                  >
                    <div style="font-size: 13px; ">
                      <strong>Cantidad total:</strong> {{ conversionData.packQuantity }} paquetes × {{ conversionData.conversionFactor }} unidades/paquete = {{ conversionData.totalQuantity.toFixed(4) }} unidades<br>
                      <strong>Precio unitario:</strong> ${{ conversionData.pricePerPack.toFixed(4) }}/paquete ÷ {{ conversionData.conversionFactor }} unidades/paquete = ${{ conversionData.unitPrice.toFixed(4) }}/unidad<br>
                      <strong>Precio total:</strong> {{ conversionData.packQuantity }} paquetes × ${{ conversionData.pricePerPack.toFixed(4) }}/paquete = ${{ conversionData.totalPrice.toFixed(4) }}
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-4">
              <v-spacer></v-spacer>
              <v-btn class="btndisable" @click="closeQuantityConversion">
                Cancelar
              </v-btn>
              <v-btn class="btn-save" @click="applyQuantityConversion">
                Aplicar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showJsonUpdate" max-width="1000px">
          <v-card>
            <v-card-title class="text-h6">Detalle de errores en el producto {{ selectedProduct?.code }}:</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <div>
                    <p style="margin: 0; padding-top: 25px; padding-bottom: 25px; font-size: 16px;"> {{`${selectedProduct?.error.message}, debe seleccionar uno para continuar.`}}</p>
                    <v-row>
                      <v-col cols="5">
                        <v-text-field
                          v-model="searchQueryBarCodes"
                          label="Buscar"
                          @keyup.enter="applyGeneralFilterBarCodes"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <div style="overflow-x: auto;">
                    <DxDataGrid
                      :data-source="filteredBarCodes"
                      key-expr="ID_Item"
                      class="grid-update"
                      column-auto-width
                      allow-column-resizing
                      column-resizing-mode="widget"
                    >
                      <DxPaging :page-size="5" />
                      <!-- <DxColumn data-field="" caption="" width="5%"></DxColumn> -->
                      <DxColumn cell-template="cell-select" caption="" width="80px"></DxColumn>
                      <DxColumn data-field="ID_Item" caption="ID" width="130px"></DxColumn>
                      <DxColumn data-field="ItemName" caption="Nombre de Producto" width="250px" cell-template="cell-template"></DxColumn>
                      <DxColumn data-field="ItemComercialName" caption="Nombre Comercial" width="250px" cell-template="cell-template"></DxColumn>
                      <DxColumn data-field="inventory_warehouse.Warehouse" caption="Almacén" width="200px"></DxColumn>
                      <DxColumn data-field="Lote" caption="Lote" width="100px"></DxColumn>
                      <DxColumn data-field="ItemCurrentQuantity" caption="Existencias" width="100px"></DxColumn>
                      <DxColumn data-field="AverageCost" caption="Costo Promedio" width="150px"></DxColumn>
                      <!-- <DxColumn data-field="" caption="" width="5%"></DxColumn> -->
                      
                      <template #cell-template="{ data }">
                        <div class="cell-centered">
                          {{ data.value }}
                        </div>
                      </template>

                      <template #cell-select="{ data }">
                        <v-btn color="blue darken-1" text @click="handleJsonDataFixes(data.data)">
                          <!-- <v-icon style="font-size: 20px;">mdi-checkbox-marked-outline</v-icon> -->
                          <v-icon style="font-size: 20px;">mdi-plus</v-icon>
                        </v-btn>
                      </template>                 
                    </DxDataGrid>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <p style="margin: 0; padding-top: 10px; padding-bottom: 10px; font-size: 16px;">Si no encuentra el producto, debera agregarlo manualmente a este proveedor desde la pestaña de productos y luego volver a intentar.</p>
            </v-card-text>
            <v-card-actions style="padding: 16px;">
              <v-spacer></v-spacer>
              <v-btn class="btndisable" @click="showJsonUpdate = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- FIN DIALOG -->

        <v-col cols="12">
          <div ref="orderItems" class="box shadow pa-5 border-5 ma-0 mt-2">
            <v-row>
              <v-col>
                <p><b>Elementos de la orden de compra actual</b></p>
              </v-col>
            </v-row>

            <v-row class="mt-6" style="justify-content: flex-end;" v-if="$store.getters['rolesUser/getCustomRole'](100)">
              <v-col cols="12" class="d-flex justify-end flex-wrap">
                <TooltipBtn
                  color="primary"
                  btnClass="mb-3"
                  :btnStyle="'margin-left: 0.5rem;'"
                  label="Importar JSON DTE completo"
                  @click="showJsonImport2 = true"
                >
                  <v-icon>mdi-invoice-import</v-icon> JSON (Completo)
                </TooltipBtn>
                <TooltipBtn
                  color="primary"
                  btnClass="mb-3"
                  :btnStyle="'margin-left: 0.5rem;'"
                  label="Importar solo encabezado JSON DTE"
                  @click="showJsonImport = true"
                >
                  <v-icon>mdi-file-import</v-icon> JSON (Encabezado)
                </TooltipBtn>
                 <TooltipBtn
                  color="primary"
                  btnClass="mb-3"
                  :btnStyle="'margin-left: 0.5rem;'"
                  label="Importar utilizando archivo excel de detalle de compras"
                  @click="showExcelImport = true"
                >
                  <v-icon>mdi-file-excel</v-icon>
                </TooltipBtn>
                <TooltipBtn
                  color="primary"
                  btnClass="mb-3"
                  :btnStyle="'margin-left: 0.5rem;'"
                  label="Descargar plantilla de importación"
                  @click="downloadPurchaseImportTemplate"
                >
                  <v-icon>mdi-download</v-icon>
                </TooltipBtn>
                <TooltipBtn
                  v-if="productsToLoad.length"
                  color="primary"
                  btnClass="mb-3"
                  :btnStyle="'margin-left: 0.5rem;'"
                  label="Ver items importados"
                  @click="showJsonLoading = true"
                >
                  <v-icon>mdi-eye</v-icon>
                </TooltipBtn>
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <!-- <v-col
                cols="12"
                md="3"
                v-if="$store.getters['rolesUser/getCustomRole'](100)"
              >
                <v-btn class="btn-json mb-3" @click="showJsonImport = true">
                  Importar solo encabezado JSON DTE
                </v-btn>
              </v-col> -->
              <v-col cols="12" md="2" class="d-flex flex-row">
                <v-btn
                  class="btn-save mr-10"
                  @click="showProducts = !showProducts"
                >
                  <v-icon>mdi-magnify</v-icon></v-btn
                >
              </v-col>
              <!-- not for "MANUEL ENRIQUE PINEDA MARTINEZ", "RECINOS BOLAINES, GUADALUPE" -->
              <template>
                <v-col cols="12" md="5">
                  <v-text-field
                    outlined
                    dense
                    v-model="selectedBarCode"
                    :items="barCodes"
                    item-text="BarCode"
                    @keyup.enter="handleBarCodEnterKey()"
                    item-value="ID_Item"
                    label="Ingrese código de barras"
                    attach
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    outlined
                    dense
                    id="input_productcode"
                    label="Ingrese código de producto"
                    v-model="itemcode"
                    @keyup.enter="handleItemCodeEnterKey()"
                  ></v-text-field>
                </v-col>
              </template>
            </v-row>
            <v-row>
              <!-- not for "MANUEL ENRIQUE PINEDA MARTINEZ", "RECINOS BOLAINES, GUADALUPE" -->
              <template>
                <v-col cols="12" :md="noProvider ? 12 : 6">
                  <v-autocomplete
                    outlined
                    dense
                    :items="ItemsByName"
                    v-model="currentIembyname"
                    @change="addproductsby()"
                    @update:search-input="onProductNameSearchInput"
                    @click:clear="clearProductNameSearch"
                    item-text="value"
                    item-value="data"
                    label="Agregar por nombre de producto"
                    attach
                    :search-input.sync="productNameSearch"
                    :loading="loadingProductNameSearch"
                    clearable
                    :no-data-text="
                      productNameSearch
                        ? (loadingProductNameSearch
                            ? 'Buscando...'
                            : 'No se encontraron coincidencias')
                        : 'Escribe al menos 3 caracteres para buscar'
                    "
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" v-if="!noProvider">
                  <v-autocomplete
                    outlined
                    dense
                    :items="ItemsByID"
                    v-model="currentIembyId"
                    @change="addproductsby()"
                    item-text="value"
                    item-value="data"
                    label="Agregar por ID de producto"
                    attach
                  ></v-autocomplete>
                </v-col>
              </template>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  outlined
                  dense
                  :items="ItemsServiceByName"
                  v-model="currentItemServiceByName"
                  @change="addservicesby()"
                  item-text="value"
                  item-value="data"
                  label="Agregar por nombre de servicio"
                  attach
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  outlined
                  dense
                  :items="ItemsServiceByID"
                  v-model="currentItemServiceById"
                  @change="addservicesby()"
                  item-text="value"
                  item-value="data"
                  label="Agregar por ID de servicio"
                  attach
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" v-if="header.purchaseordertype == 'FE'">
                <v-select
                  outlined
                  dense
                  v-model="header.coddocasociado"
                  attach
                  :items="codigosAsociadosEx"
                  item-value="id"
                  item-text="valor"
                  label="Código de documento asociado"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" v-if="header.purchaseordertype == 'FE'">
                <v-text-field
                  v-model="header.docasociado"
                  dense
                  outlined
                  label="Documento asociado"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3" v-if="header.purchaseordertype == 'FE'">
                <v-text-field
                  v-model="header.detalledocasociado"
                  dense
                  outlined
                  label="Detalle de documento asociado"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" v-if="header.purchaseordertype == 'FE'">
                <v-text-field
                  v-model="header.flete"
                  type="number"
                  dense
                  outlined
                  label="Flete"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" v-if="header.purchaseordertype == 'FE'">
                <v-text-field
                  v-model="header.seguro"
                  type="number"
                  dense
                  outlined
                  label="Seguro"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-divider class="my-2"></v-divider>
            </v-row>
            <v-row class="mt-8">
              <v-col cols="12" md="6">
                <v-autocomplete
                  outlined
                  dense
                  :items="warehouses"
                  v-model="globalWarehouse"
                  item-text="Warehouse"
                  item-value="ID_Warehouse"
                  label="Seleccione un almacén para asignar a todos los productos"
                  attach
                ></v-autocomplete>
              </v-col>
              <v-col class="d-flex bg-surface-variant" cols="12" md="6">
                <v-btn class="btn-save" @click="assingWarehouseGlobally()">
                  Asignar a Todos
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" v-if="header.purchaseordertype == 'FI' || header.purchaseordertype == 'DDM'">
                <v-text-field dense outlined label="Ingresar porcentaje de IVA (%)" v-model="percentIvaFi"></v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex align-end justify-end">
                <v-checkbox
                  :label="header.purchaseordertype == 'NC' ? 'Factura es nota de crédito' : 
                          header.purchaseordertype == 'ND' ? 'Factura es nota de débito' : 
                          header.purchaseordertype == 'FI' ? 'Factura es de importación' : 
                          header.purchaseordertype == 'DDM' ? 'Declaración de mercancías' :
                          'Factura es crédito fiscal'"
                  :value="checkboxIva"
                  @change="handleCheckboxIva"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="globalDiscount" class="d-flex align-center justify-end">
              <div 
                class="d-flex align-center mr-4" 
                style="
                  font-size: 1.25rem;
                  color: #263238;
                "
              >
                <div 
                  class="mr-2"
                >
                  Descuento global:
                </div>
                <div style="color: #1B5E20;">
                  {{  `$${globalDiscount}`  }}
                </div>
              </div>
              <Button
                v-if="!globalDiscountOnAll"
                size="small"
                @click="applyGlobalDiscountToAll"
                prepend-icon="mdi-checkbox-multiple-marked"
                class="mr-2"
              >
                Aplicar a todos
              </Button>
              <Button
                v-if="globalDiscountOnSome"
                size="small"
                color="warning"
                prepend-icon="mdi-checkbox-multiple-blank-outline"
                @click="removeGlobalDiscountFromAll"
              >
                Quitar de todos
              </Button>
            </v-row>
            <v-row style="overflow-x: scroll">
              
              <v-btn class="btn-save mb-3" @click="showColumnConfig = true">
                <v-icon>mdi-table-edit</v-icon>&nbsp;Configurar columnas
              </v-btn>
              
              
              <v-dialog v-model="showColumnConfig" max-width="500">
                <v-card>
                  <v-card-title>Configuración de columnas</v-card-title>
                  <v-card-text>
                    <v-checkbox v-model="columnsConfig.showBarCode" label="Mostrar columna Código alterno"/>
                    <v-checkbox v-model="columnsConfig.showBatch" label="Mostrar columna Lote"/>
                    <v-checkbox v-model="columnsConfig.showExpiration" label="Mostrar columna Expiración"/>
                    <v-checkbox v-model="columnsConfig.showWarehouse" label="Mostrar columna Almacén"/>
                    <v-checkbox v-model="columnsConfig.showHydrocarbon" label="Mostrar columna Hidrocarburo"/>
                    <v-checkbox v-model="columnsConfig.showExempt" label="Mostrar columna Exento"/>
                    <v-checkbox v-model="columnsConfig.showNotSubject" label="Mostrar columna No Sujeto"/>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="btndisable" @click="showColumnConfig = false">Cerrar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <DxDataGrid
                class="mt-4"
                style="width: fit-content !important"
                column-auto-width
                :data-source="
                  productsFiltered === false
                    ? productsToShow
                    : productsToShowFiltered
                "
                key-expr="ID_Item"
              >
                <DxColumn
                  cell-template="row-number"
                  caption="#"
                  width="50px"
                />
                <DxColumn
                  data-field="ID_Item"
                  caption="ID"
                  width="120px"
                ></DxColumn>
                <DxColumn
                  v-if="columnsConfig.showBarCode"
                  data-field="BarCode"
                  caption="Código alterno"
                  width="120px"
                ></DxColumn>
                <DxColumn data-field="ItemName" caption="Producto" width="400"></DxColumn>
                <DxColumn
                  v-if="columnsConfig.showBatch"
                  width="100px"
                  cell-template="product-batch"
                  caption="Lote"
                ></DxColumn>
                <DxColumn
                  v-if="columnsConfig.showExpiration"
                  cell-template="product-expirationdate"
                  caption="Expiración"
                  width="120px"
                ></DxColumn>
                <DxColumn
                  v-if="requireExpirationDateInventoryPurchases"
                  cell-template="product-without-expirationdate"
                  caption="Producto sin fecha de vencimiento"
                  width="150px"
                ></DxColumn>
                <DxColumn
                  v-if="columnsConfig.showWarehouse"
                  cell-template="warehouse-selection"
                  caption="Almacen"
                  width="150px"
                ></DxColumn>
                <DxColumn
                  cell-template="product-quantity"
                  caption="Cantidad"
                  width="90px"
                ></DxColumn>
                <DxColumn
                width="90px"
                cell-template="product-unitcost"
                caption="Cost./U"
                ></DxColumn>
                
                <DxColumn
                  v-if="globalDiscount && globalDiscount > 0"
                  cell-template="applyGlobalDiscount"
                  caption="Con descuento"
                  width="100px"
                ></DxColumn>
                <template #applyGlobalDiscount="{ data }">
                  <input 
                    type="checkbox" 
                    v-model="data.data.applyGlobalDiscount"
                    @change="onApplyGlobalDiscountChange(data.data)"
                    :value="data.data.applyGlobalDiscount"
                    :disabled="!data.data.qty || !data.data.price"
                  />
                </template>

                <DxColumn
                  v-if="columnsConfig.showHydrocarbon"
                  cell-template="isHidrocarburo"
                  caption="Hidrocarburo"
                  width="90px"
                ></DxColumn>
                <!--DxColumn cell-template="Isiva" caption="Iva" width="90px">
                </DxColumn-->
                <DxColumn
                  v-if="columnsConfig.showExempt" 
                  cell-template="IsExento" 
                  caption="Exento" 
                  width="90px"
                ></DxColumn>
                <template #IsExento="{ data }">
                  <input type="checkbox" @click="data.data.IsNoSujeto = false;" v-model="data.data.IsExento" />
                </template>
                <DxColumn
                  v-if="columnsConfig.showNotSubject"
                  cell-template="IsNoSujeto"
                  caption="No Sujeto"
                  width="90px"
                ></DxColumn>
                <template #IsNoSujeto="{ data }">
                  <input type="checkbox" @click="data.data.IsExento = false;" v-model="data.data.IsNoSujeto" />
                </template>
                
                <DxColumn
                  width="90px"
                  cell-template="total-quantity"
                  caption="Total"
                ></DxColumn>
                <DxColumn
                  :width="32"
                  cell-template="show-template"
                  caption=""
                ></DxColumn>

                <template #row-number="{ data }">
                  {{ data.rowIndex + 1 }}
                </template>

                <template #warehouse-selection="{ data }">
                  <span class="scroll-fixing-purchase">
                    <select
                      class="form-control custom-select"
                      v-model="data.data.ID_Warehouse"
                    >
                      <option
                        v-for="warehouse in warehouses"
                        :value="warehouse.ID_Warehouse"
                        :key="warehouse.ID_Warehouse"
                      >
                        {{ warehouse.Warehouse }}
                      </option>
                    </select>
                  </span>
                </template>

                <template #show-template="{ data }">
                  <a
                    href="#"
                    class="mx-1"
                    @click.prevent.stop="
                      showCustomer = data;
                      removeRow(data);
                    "
                  >
                    <v-icon color="error">mdi-delete</v-icon>
                  </a>
                </template>

                <template #product-batch="{ data }">
                  <input v-if="data.data.ItemType != 'service'" type="text" maxlength="20" v-model="data.data.ID_ItemBatch" />
                </template>
                <template #product-expirationdate="{ data }">
                  <input v-if="data.data.ItemType != 'service'" type="date" v-model="data.data.ExpirationDate" />
                </template>
                <template #product-without-expirationdate="{ data }">
                  <input v-if="data.data.ItemType != 'service'" type="checkbox" v-model="data.data.ProductWithoutExpirationDate" />
                </template>
                <template #product-quantity="{ data }">
                  <div style="display: flex; align-items: center; gap: 2px;">
                    <input 
                      type="number" 
                      v-model="data.data.qty" 
                      :disabled="data.data.applyGlobalDiscount"
                      :style="{ color: data.data.applyGlobalDiscount ? '#1565C0' : '', width: '55px' }"
                    />
                    <span 
                      @click="openQuantityConversionFromMain(data.data, data.rowIndex)"
                      style="
                        cursor: pointer;
                        color: #1976d2;
                        font-size: 18px;
                        display: inline-flex;
                        align-items: center;
                        padding: 2px;
                      "
                      title="Calcular conversión"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                        <path d="M7,2H17A2,2 0 0,1 19,4V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V4A2,2 0 0,1 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z" />
                      </svg>
                    </span>
                  </div>
                </template>
                <template #isHidrocarburo="{ data }">
                  <input type="checkbox" v-model="data.data.IsHidrocarburo" :disabled="true"/>
                </template>
                <template #product-unitcost="{ data }">
                  <input
                    type="number"
                    v-model="data.data.ItemNewPrice"
                    value="0"
                    :disabled="data.data.applyGlobalDiscount"
                    @input="ev => onUnitCostChange(ev.target?.value, data.data)"
                    :style="{ color: data.data.applyGlobalDiscount ? '#1565C0' : '' }"
                  />
                </template>
                <template #Isiva="{ data }">
                  <input type="checkbox" @click="data.data.IsExento = false; data.data.IsNoSujeto = false;" v-model="data.data.iva" />
                </template>
                <template #total-quantity="{ data }">
                  $ {{ data.data.ItemPriceQty }}
                </template>
              </DxDataGrid>
              <!-- <GeneralFilter style="width: 100%;" :search="{}" :filterEndpoint="filterPromise" @emptyFilter="clearFilter" @filtered="filterHandler" > -->
              <!-- <DxDataGrid class="isScrolledByGeneralFilter" :data-source="producstFiltered ? productsToShow : productsToShowFiltered" key-expr="ID_Item" class="mt-4" style="min-width: 1000px"> -->
              <!-- </GeneralFilter> -->
            </v-row>
            <v-col ref="summary" class="mt-5 box invoiceResponsiveSummary"
            :style="fixedFooter ? fixedFooterStyle : null">
               <v-row cols="12" class="py-1 justify-center align-center">
                  <!-- ROW CONTROLS -->
                  <v-col cols="12" xl="6">
                    <v-row cols="12" class="mt-3 mb-1 justify-center">
                      <v-col cols="6" md="3" lg="2" class="responsiveSmallCol py-2">
                        <v-row class="d-flex justify-center">
                          <span id="subtotal">Subtotal</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.subTotal"
                            disabled
                            aria-describedby="subtotal"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="6" md="3" lg="2" class="responsiveSmallCol py-2" v-if="isTaxCredit()">
                        <v-row class="d-flex justify-center">
                          <span id="IVA">IVA {{(header.purchaseordertype == 'FI' || header.purchaseordertype == 'DDM') ? percentIvaFi : 13 }}%</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.iva"
                            disabled
                            aria-describedby="IVA"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="6" md="3" lg="2" class="responsiveSmallCol py-2">
                        <v-row class="d-flex justify-center">
                          <span id="NON-TAXABLE">Exento</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.exento"
                            disabled
                            aria-describedby="NON-TAXABLE"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="6" md="3" lg="2" class="responsiveSmallCol py-2">
                        <v-row class="d-flex justify-center">
                          <span id="NON-TAXABLE">No Sujeto</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.nosujeto"
                            disabled
                            aria-describedby="NON-TAXABLE"
                          />
                        </v-row>
                      </v-col>
                      <v-col v-if="sumObject.reterenta > 0" cols="6" md="3" lg="2" class="responsiveSmallCol py-2">
                        <v-row class="d-flex justify-center">
                          <span id="NON-TAXABLE">Rete Renta</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.reterenta"
                            disabled
                            aria-describedby="NON-TAXABLE"
                          />
                        </v-row>
                      </v-col>
                      <v-col v-if="sumObject.ivaret > 0" cols="6" md="3" lg="2" class="responsiveSmallCol py-2">
                        <v-row class="d-flex justify-center">
                          <span id="NON-TAXABLE">IVA Retenido (US$)</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.ivaret"
                            disabled
                            aria-describedby="NON-TAXABLE"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="6" md="3" lg="2" class="responsiveSmallCol py-2" v-if="isTaxCredit()">
                        <v-row class="d-flex justify-center">
                          <span id="NON-TAXABLE">IVA Percibido (US$)</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.ivaperc"
                            disabled
                            aria-describedby="NON-TAXABLE"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="6" md="3" lg="2" class="responsiveSmallCol py-2" v-if="showFuelTaxes">
                        <v-row class="d-flex justify-center">
                          <span id="NON-TAXABLE">Fovial</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.fovial"
                            disabled
                            aria-describedby="NON-TAXABLE"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="6" md="3" lg="2" class="responsiveSmallCol py-2" v-if="showFuelTaxes">
                        <v-row class="d-flex justify-center">
                          <span id="NON-TAXABLE">Cotrans</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control"
                            :value="sumObject.cotrans"
                            disabled
                            aria-describedby="NON-TAXABLE"
                          />
                        </v-row>
                      </v-col>
                      <v-col cols="6" :md="isTaxCredit() ? '3' : '3'" lg="2" class="responsiveSmallCol py-2">
                        <v-row class="d-flex justify-center">
                          <span id="VENTAS-TOTAL">Total (US$)</span>
                        </v-row>
                        <v-row class="d-flex justify-center mb-1">
                          <input
                            type="text"
                            class="form-control total-value"
                            :value="sumObject.total"
                            disabled
                            aria-describedby="VENTAS-TOTAL"
                          />
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- ROW BUTTONS -->
                  <v-col cols="12" xl="4" id="summary-buttons">
                    <v-row cols="12" class="mt-0 mb-1 d-flex justify-center">
                      <!-- <v-col cols="3">
                        </v-col> -->
                      <v-col cols="3" sm="2" md="2" lg="1" xl="2"  class="d-flex py-2 justify-center align-center">
                        <v-btn
                          class="btnclean"
                          style="height: 45px"
                          @click.prevent.stop="resetData()"
                        >
                          <v-icon>mdi-broom</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="3" sm="2" md="2" lg="1" xl="2" class=" d-flex py-2 justify-content-center align-center" >
                        <v-btn
                          v-if="$store.getters['rolesUser/getCustomRole'](99)"
                          style="height: 45px"
                          class="btn-save mx-auto"
                          @click="
                            print = {
                              show: true,
                              data: {
                                header: header,
                                extraHeader: {
                                  ID_Provider: data.ID_Provider,
                                  img: url,
                                },
                                body: productsToShow,
                                totalinvoice: sumObject,
                              },
                            }
                          "
                        >
                          <v-icon>mdi-printer-pos</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" sm="4" md="3" lg="2" xl="4" class="d-flex py-2 justify-center  align-center">
                        <Button
                          v-if="$store.getters['rolesUser/getCustomRole'](101)"
                          :throttleTime="500"
                          @click.prevent.stop="addPurchaseOrder('notprocess')" 
                          :disabled="disableButtons"
                          style="height: 45px;"
                        >
                          GUARDAR ORDEN 
                          <br/> 
                          DE COMPRA
                        </Button>
                      </v-col>
                      <v-col cols="12" sm="4" md="3" lg="2" xl="4" class=" d-flex py-2 justify-center align-center"  >
                        <Button
                          color="success"
                          v-if="
                            header.purchaseordertype != 'FNS' &&
                            $store.getters['rolesUser/getCustomRole'](98)
                          "
                          :throttleTime="500"
                          @click.prevent.stop="validateCorrelative('process')"
                          style="height: 45px;"
                          :disabled="disableButtons"
                        >
                          PROCESAR ORDEN 
                          <br/> 
                          DE COMPRA
                        </Button>

                        <Button
                          v-if="
                            header.purchaseordertype == 'FNS' &&
                            $store.getters['rolesUser/getCustomRole'](98)
                          "
                          color="success"
                          :throttleTime="500"
                          @click.prevent.stop="validateCorrelative('process')"
                          style="height: 45px;"
                          :disabled="disableButtons"
                        >
                          PROCESAR ORDEN 
                          <br/> 
                          DE COMPRA
                        </Button>
                      </v-col>
                      <!-- <v-col cols="1">
                        </v-col> -->
                  </v-row>
                  </v-col>
               </v-row>
            </v-col>
          </div>
        </v-col>
      </v-row>
    </v-form>
    <alerts
      :key="1"
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    >
    </alerts>
    <alerts
      :key="1"
      v-if="doc_alert.show"
      v-on:status_alert="statusAlert"
      :properties="doc_alert"
    >
    </alerts>
    <print-purchase-order :data="print"></print-purchase-order>

    <!-- <v-footer
    class="box navbar toHide fixed-summary"
      v-if="$store.getters.getDrawerMini == false"
      rounded="lg"
      style="
        align-self: flex-end;
        display: flex;
        width: calc(100% - 250px);
        background: #41464c;
        color: white;
        bottom: 0;
        left: 180px;
        align-self: flex-start;
        z-index: 99999999;
        justify-content: space-between;
        position: fixed;
        height: fit-content;
        padding: 16px 16px;
        flex-wrap: wrap">
      <v-row>

        <v-col cols="8" >
          <v-row class="d-flex justify-center">
            <v-col>
              <span class="input-group-text" id="subtotal">Sub Total</span>
              <div>
                <input
                  type="text"
                  class="form-control"
                  :value="sumObject.subTotal"
                  disabled
                  aria-describedby="subtotal"
                />
              </div>
            </v-col>
            <v-col v-if="isTaxCredit()">
              <span class="input-group-text" id="IVA">IVA {{(header.purchaseordertype == 'FI' || header.purchaseordertype == 'DDM') ? percentIvaFi : 13 }}%</span>
              <div>
                <input
                  type="text"
                  class="form-control"
                  :value="sumObject.iva"
                  disabled
                  aria-describedby="IVA"
                />
              </div>
            </v-col>
            <v-col>
              <span class="input-group-text" id="IVA">Exento</span>
              <div>
                <input
                  type="text"
                  class="form-control"
                  :value="sumObject.exento"
                  disabled
                  aria-describedby="IVA"
                />
              </div>
            </v-col>
            <v-col>
              <span class="input-group-text" id="IVA">No Sujeto</span>
              <div>
                <input
                  type="text"
                  class="form-control"
                  :value="sumObject.nosujeto"
                  disabled
                  aria-describedby="IVA"
                />
              </div>
            </v-col>
            <v-col v-if="sumObject.reterenta > 0">
              <span class="input-group-text" id="NON-TAXABLE">Rete Renta</span>
              <div>
                <input
                  type="text"
                  class="form-control"
                  :value="sumObject.reterenta"
                  disabled
                  aria-describedby="NON-TAXABLE"
                />
              </div>
            </v-col>
            <v-col v-if="sumObject.ivaret > 0">
              <span class="input-group-text" id="NON-TAXABLE">IVA Retenido</span>
              <div>
                <input
                  type="text"
                  class="form-control"
                  :value="sumObject.ivaret"
                  disabled
                  aria-describedby="NON-TAXABLE"
                />
              </div>
            </v-col>
            <v-col v-if="header.purchaseordertype == 'CCF' || header.purchaseordertype == 'NC' || header.purchaseordertype == 'ND' || header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM'">
              <span class="input-group-text" id="NON-TAXABLE">IVA Percibido</span>
              <div>
                <input
                  type="text"
                  class="form-control"
                  :value="sumObject.ivaperc"
                  disabled
                  aria-describedby="NON-TAXABLE"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="2" lg="4">
          <v-row class="d-flex justify-center">
            <v-col>
              <span class="input-group-text" id="VENTAS-TOTAL">TOTAL (US$)</span>
              <div>
                <input
                  type="text"
                  class="form-control total-value"
                  :value="sumObject.total"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="6" lg="5">
          <v-row>
            <v-col>
              <v-btn
                style="margin-top: 5px; height: 45px"
                class="btnclean"
                @click.prevent.stop="resetData()"
              >
              <v-icon>mdi-broom</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                style="margin-top: 5px; height: 45px"
                class="btn-save"
                @click="
                  print = {
                    show: true,
                    data: {
                      header: header,
                      extraHeader: { ID_Provider: data.ID_Provider, img: url },
                      body: productsToShow,
                      totalinvoice: sumObject,
                    },
                  }
                "
              >
              <v-icon>mdi-printer-pos</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                style="margin-top: 5px; height: 45px"
                class="btn-save"
                @click.prevent.stop="addPurchaseOrder('notprocess')"
                v-if="$store.getters['rolesUser/getCustomRole'](101)"
                :disabled="disableButtons"
              >
                GUARDAR ORDEN
                <br />
                DE COMPRA
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                v-if="
                  header.purchaseordertype != 'FNS' &&
                  $store.getters['rolesUser/getCustomRole'](98)
                "
                style="margin-top: 5px; height: 45px"
                class="btn-save"
                @click.prevent.stop="addPurchaseOrder('process')"
                :disabled="disableButtons"
              >
                PROCESAR ORDEN
                <br />
                DE COMPRA
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                v-if="
                  header.purchaseordertype == 'FNS' &&
                  $store.getters['rolesUser/getCustomRole'](98)
                "
                style="margin-top: 5px; height: 45px"
                class="btn-save"
                @click.prevent.stop="addFnsPurchaseOrder()"
                :disabled="disableButtons"
              >
                PROCESAR ORDEN
                <br />
                DE COMPRA
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-footer>

    <footer
      class="box navbar toHide"
      v-if="$store.getters.getDrawerMini == true"
      style="
        align-self: flex-end;
        display: flex;
        min-width: calc(100% - 90px);
        background: #41464c;
        color: white;
        bottom: 0;
        left: 40px;
        align-self: flex-start;
        z-index: 99999999;
        justify-content: space-between;
        position: fixed;
      "
    >
      <div class="input-group mb-3 ml-2">
        <div class="input-group-prepend">
          <span class="input-group-text" id="subtotal">Sub Total</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.subTotal"
          disabled
          aria-describedby="subtotal"
        />
      </div>
      <div class="input-group mb-3" v-if="isTaxCredit()">
        <div class="input-group-prepend">
          <span class="input-group-text" id="IVA">IVA {{(header.purchaseordertype == 'FI' || header.purchaseordertype == 'DDM') ? percentIvaFi : 13 }}%</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.iva"
          disabled
          aria-describedby="IVA"
        />
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="IVA">Exento</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.exento"
          disabled
          aria-describedby="IVA"
        />
      </div>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="IVA">No Sujeto</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.nosujeto"
          disabled
          aria-describedby="IVA"
        />
      </div>

      <div class="input-group mb-3" v-if="sumObject.reterenta > 0">
        <div class="input-group-prepend">
          <span class="input-group-text" id="NON-TAXABLE">Rete Renta</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.reterenta"
          disabled
          aria-describedby="NON-TAXABLE"
        />
      </div>

      <div class="input-group mb-3" v-if="sumObject.ivaret > 0">
        <div class="input-group-prepend">
          <span class="input-group-text" id="NON-TAXABLE">IVA Retenido (US$)</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.ivaret"
          disabled
          aria-describedby="NON-TAXABLE"
        />
      </div>

      <div class="input-group mb-3" v-if="isTaxCredit()">
        <div class="input-group-prepend">
          <span class="input-group-text" id="NON-TAXABLE">IVA Percibido (US$)</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.ivaperc"
          disabled
          aria-describedby="NON-TAXABLE"
        />
      </div>
      
      <div class="input-group mb-3" v-if="showFuelTaxes">
        <div class="input-group-prepend">
          <span class="input-group-text" id="NON-TAXABLE">Fovial</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.fovial"
          disabled
          aria-describedby="NON-TAXABLE"
        />
      </div>
      <div class="input-group mb-3" v-if="showFuelTaxes">
        <div class="input-group-prepend">
          <span class="input-group-text" id="NON-TAXABLE">Cotrans</span>
        </div>
        <input
          type="text"
          class="form-control"
          :value="sumObject.cotrans"
          disabled
          aria-describedby="NON-TAXABLE"
        />
      </div>

      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="VENTAS-TOTAL">TOTAL (US$)</span>
        </div>
        <input
          type="text"
          class="form-control totalDesignGlobal"
          :value="sumObject.total"
          disabled
          aria-describedby="VENTAS-TOTAL"
        />
      </div>

      <div style="text-align: center" class="mb-2">
        <v-btn
          style="margin-top: 10px"
          class="btnclean"
          @click.prevent.stop="resetData()"
        >
          <v-icon>mdi-broom</v-icon>
        </v-btn>
      </div>

      <div style="text-align: center" class="mb-2">
        <v-btn
          style="margin-top: 10px"
          class="btn-save"
          @click="
            print = {
              show: true,
              data: {
                header: header,
                extraHeader: { ID_Provider: data.ID_Provider, img: url },
                body: productsToShow,
                totalinvoice: sumObject,
              },
            }
          "
        >
          <v-icon>mdi-printer-pos</v-icon>
        </v-btn>
      </div>

      <div style="text-align: center" class="mb-2">
        <v-btn
          v-if="$store.getters['rolesUser/getCustomRole'](101)"
          style="margin-top: 10px"
          class="btn-save"
          @click.prevent.stop="addPurchaseOrder('notprocess')"
          :disabled="disableButtons"
        >
          GUARDAR ORDEN
          <br />
          DE COMPRA
        </v-btn>
      </div>

      <div style="text-align: center" class="mb-2">
        <v-btn
          v-if="
            header.purchaseordertype != 'FNS' &&
            $store.getters['rolesUser/getCustomRole'](98)
          "
          style="margin-top: 10px"
          class="btn-save"
          @click.prevent.stop="addPurchaseOrder('process')"
          :disabled="disableButtons"
        >
          PROCESAR ORDEN
          <br />
          DE COMPRA
        </v-btn>

        <v-btn
          v-if="
            header.purchaseordertype == 'FNS' &&
            $store.getters['rolesUser/getCustomRole'](98)
          "
          style="margin-top: 10px"
          class="btn-save"
          @click.prevent.stop="addFnsPurchaseOrder()"
        >
          PROCESAR ORDEN
          <br />
          DE COMPRA
        </v-btn>
      </div>
    </footer> -->

    <print-pos-fa
      :dataProps="print2"
      @mailSent="
        () => {
          showAlert(
            'success',
            'Correo enviado',
            'Se ha enviado el detalle de la factura correctamente'
          );
        }
      "
    ></print-pos-fa>
  </div>
</template>

<script>
import DatePicker from "../../../components/DatePicker";
import Block from "@/components/Block";
import Vue from "vue";
import { DxDataGrid, DxColumn, DxPaging } from "devextreme-vue/data-grid";
import Alerts from "@/components/Alerts";
import JsonProductManager from "@/components/inventory/JsonProductManager.vue";
import PurchaseDetailImport from "@/components/inventory/PurchaseDetailImport.vue";
import PrintPurchaseOrder from "../../../components/ReportsAndPrintings/PrintPurchaseOrder";
import { mapState } from "vuex";
import GeneralFilter from "@/components/GeneralFilter";
import { multipleCriteriaFilter } from "@/helpers/object";
import { formatDate } from "@/helpers/formatDate";
import { mapGetters } from "vuex";
import PrintPosFa from "@/components/ReportsAndPrintings/PrintPosFa";
import { numberToText } from "../../../helpers/conveterNumberText";
import CustomCSVPeriod from "@/components/Misc/CustomCSVPeriod";
import ClasificationRentaAutocomplete from "../../../components/Misc/ClasificationRentaAutocomplete.vue";
import Dialog from '@/components/Dialog.vue';
import Button from "@/components/Button.vue";
import TooltipBtn from "../../../components/TooltipBtn.vue";
import { downloadPurchaseDetailImportTemplate } from "@/helpers/purchaseDetailImportTemplate";
import { findSelloRecibido, parseJsonRelaxedCanonical } from "@/helpers/parseJson";

const isTruthyFlag = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

const printPosFaConstructor = Vue.extend(PrintPosFa);

export default {
  name: "AddPurchase",
  props: ["data", "win"],
  components: {
    DatePicker,
    DxDataGrid,
    DxColumn,
    DxPaging,
    GeneralFilter,
    Block,
    Alerts,
    PrintPurchaseOrder,
    PrintPosFa,
    CustomCSVPeriod,
    ClasificationRentaAutocomplete,
    Dialog,
    Button,
    JsonProductManager,
    PurchaseDetailImport,
    TooltipBtn,
  },
  data() {
    return {
      keymaster: "",
      globalWarehouse: "",
      showComment: false,
      submitCustomCSVPeriodState: false,
      showBgcolorNotes: "tabs",
      showInfoPurchase: false,
      showProducts: false,
      invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito"],
      paymentMethod: [
        "Efectivo",
        "Cheque",
        "Transferencia",
        "Tarjeta de Crédito",
        "Otro",
      ],
      days: ["8 Dias", "15 Dias", "30 Dias", "90 Dias", "120 Dias", "180 Dias"],
      print: {
        show: false,
        data: [],
      },
      print2: {
        show: false,
        data: [],
      },
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
        onAccept: null,
        onCancel: null,
      },
      doc_alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
        status: false,
        resolve: null,
      },
      form: {},
      requiredRule: [(value) => !!value || "Required."],
      valid: false,
      url: null,
      image: null,
      warehouses: [],
      currentIembyId: null,
      currentIembyname: null,
      currentItemServiceById: null,
      currentItemServiceByName: null,
      productNameSearch: "",
      remoteItemsByName: [],
      loadingProductNameSearch: false,
      productNameSearchTimeout: null,
      productNameSearchRequestId: 0,
      loading: false,
      value: null,
      readonly: true,
      orderid: null,
      purchaseorderdate: formatDate(new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(0, 10)),
      purchaseinvoicedate: formatDate(new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(0, 10)),
      //This object use for loading de elements for select box "Invoice Type"
      invoiceTypes: [],
      //items:[],
      //Object that contains the info of purchase order header
      header: {
        flete: '',
        seguro: '',
        ClasificationRent: '1',
        NumeroDocumentoRelacionado: '',
        selloRecibido: null
      },
      //Objects for the section "Filters"
      showFilter: false,
      showJsonImport: false,
      showExcelImport: false,
      filterProducts: {},
      detailsToshow: false,
      priceList: [
        {
          PriceListName: "TODOS",
        },
      ],
      types: ["TODOS", "PRODUCTO"],
      //Objects for the tables of products
      productsToBill: [],
      servicesToBill: [],
      productsToShow: [],
      globalDiscount: 0.0,
      newItem: null,
      barcode: null,
      itemcode: null,
      taxPayerSize: null,
      BusinessLegalAgentRetain: false,
      requireExpirationDateInventoryPurchases: false,
      documentOptions: [
        { value: "1", text: "Físico" },
        { value: "2", text: "Electrónico" },
      ],
      productsToShowFiltered: [],
      productsFiltered: false,
      search: {
        filter: null,
      },
      //Objects from JSON import
      showJsonImport2: false,
      showJsonLoading: false,
      jsonProcessing: false,
      showJsonUpdate: false,
      loadingJson: false,
      currentImportSource: null,
      catalogTypedocument: [],
      selectedFile: null,
      jsonData: null,
      selectedProduct: null,
      productsToLoad: [],
      pendingExcelSkippedRows: [],
      allProvidersBarCodes: [],
      allProvidersInventoryItems: [],
      filteredBarCodes: [],
      searchQueryBarCodes: '',
      barCodes: [],
      selectedBarCode: null,
      barCodeToFind: null,
      // Variables para conversión de cantidad
      showQuantityConversion: false,
      conversionData: {
        productIndex: null,
        product: null,
        productCode: null,
        productDescription: null,
        originalQuantity: 0,
        originalPrice: 0,
        packQuantity: 1,
        conversionFactor: 1,
        pricePerPack: 0,
        totalQuantity: 0,
        totalPrice: 0,
        unitPrice: 0
      },
      datatoprint: {
        branch: JSON.parse(localStorage.getItem("branch")),
        user: JSON.parse(localStorage.getItem("user")),
        header: null,
        body: null,
        dteJson: null,
      },
      noProvider: isTruthyFlag(
        JSON.parse(localStorage.getItem("user"))?.nomergeprodwithprovs
      ),
      displayInvoice: "products",
      checkboxIva: false,
      cleanState: false,
      codigosAsociadosEx: [
        {
          id: 4,
          valor: "Transporte",
        },
        {
          id: 1,
          valor: "Emisor",
        },
        {
          id: 2,
          valor: "Receptor",
        },
      ],
      showFuelTaxes: false,
      cotrans: parseFloat(0).toFixed(4),
      fovial: parseFloat(0).toFixed(4),
      flete: parseFloat(0).toFixed(2),
      seguro: parseFloat(0).toFixed(2),
      text: "",
      percentIvaFi: 0,
      showColumnConfig: false,
      columnsConfig: {
        showBarCode: true,
        showBatch: true,
        showExpiration: true,
        showWarehouse: true,
        showHydrocarbon: true,
        showExempt: true,
        showNotSubject: true,
      },
      parentBottom: 0,
      fixedFooter: false,
      fixedFooterStyle: {
        position: 'fixed',
        bottom: '0',
        left: '0',
        width: '100%',
        zIndex: 995,
      },
      orderList: [],
      loadingProducts: false,
      noProviderFilter: [
        '689510125c294fa0c2b02d6200cceb7f', 
        'bc6bb5650ed8c31cf987f8bdc005ea00', 
        'c2945d5f5599348ca2ba04d7b5524637', 
        '55652726b965155654981d279f4900bf',
        '47770e9a83f6f46af2a3d2b93fff710a',
        'd76ca00b6f45acf9815bc10e1d9b7652',
        '7c048837d3fed617a0dc72344a5e3da6',
        '0a9e451bcfa7e7db984f3e7f27e1bd56',
        'ecbfba3a7cf5697352a16eecb423adbf',
        '4b487acd19dd9537e23c7cf640ed59bc',
        "b32e3f3038710e3ca5fbdad5dd2e6353",
        "72c114c6e9b4e9a474cd435df5b21dc4",
        "b508c44089be0e1f65e56ac1442e0a5e",
        "35c2a27155cddda501b58cb96fb29648",
        "c6685ca904614e1613cedce0665cc497",
      ]
    };
  },
  created() {
    this.$store.dispatch("getParam", { type: "Invoice" }).then((data) => {
      this.invoiceTypes = data.map((param) => {
        return { text: param.ParameterName, value: param.ParameterValue };
      });
    });
  },
  watch: {
    filterProducts: {
      deep: true,
      handler: "getProducts",
    },
    percentIvaFi: {
      handler() {
        this.productsToShow.forEach(data => {
          let total = (data.ItemNewPrice * data.qty * (1 + (parseFloat(this.percentIvaFi)/100)) ).toFixed(8);
          Vue.set(data, "ItemPriceQty", total)
        }); 
      }
    },
    productsToShow: {
      deep: true,
      handler(newValue) {
        newValue.forEach((data) => {
          if(data.IsHidrocarburo) {
            this.showFuelTaxes = true;
          }
          if (this.header.purchaseordertype == 'CCF' || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') data.iva = true;

          if (data.iva) {
            if (data.IsExento 
              || data.IsNoSujeto 
              || this.header.purchaseordertype == 'CCF'
              || this.header.purchaseordertype == 'NC' 
              || this.header.purchaseordertype == 'ND'
            ) { // Exento or No Sujeto
              data.ItemPriceQty = ((data.ItemNewPrice * data.qty)).toFixed(8)
            }
            else if (this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') {
              data.ItemPriceQty = (data.ItemNewPrice * data.qty * (1 + (parseFloat(this.percentIvaFi)/100)) ).toFixed(
                8
              );
            }
            else {
              data.ItemPriceQty = (data.ItemNewPrice * data.qty * 1.13).toFixed(
                8
              );
            }
          } else if (!data.iva) {
            if (data.IsExento || data.IsNoSujeto) {
              data.ItemPriceQty = ((data.ItemNewPrice * data.qty)).toFixed(8);
            }
            else {
              data.ItemPriceQty = (data.ItemNewPrice * data.qty).toFixed(8);
            }
            
          }
        });
      },
    },
    purchaseorderdate: {
      handler: function () {
        this.header.purchaseorderdate = this.purchaseorderdate;
      },
      immediate: true,
    },
    purchaseinvoicedate: {
      handler: function () {
        this.header.purchaseinvoicedate = this.purchaseinvoicedate;
      },
      inmmediate: true,
    },
    allProvidersInventoryItems: {
      handler(newValue) {
        this.filteredBarCodes = newValue;
      },
      inmmediate: true,
    },
    "header.purchaseordertype"() {
      this.sumObject
    }
  },
  computed: {   
    globalDiscountOnAll() {
      if (!this.productsToShow) {
        return false;
      }

      return this.productsToShow.every(p => p.applyGlobalDiscount === true);
    },
    globalDiscountOnSome() {
      console.log('SOME');

      if (!this.productsToShow) {
        return false;
      }
      
      return this.productsToShow.some(p => p.applyGlobalDiscount === true);
    },
    disableButtons(){
      return this.loading || this.alert.show;
    },
    ...mapGetters(['getCatalogMH']),
    paymentTypes() {
      return this.getCatalogMH("FormaPago");
    },
    tipoIngresoProveedores() {
      return this.getCatalogMH('TipoIngresoProveedores');
    },
    sectorProveedores() {
      return this.getCatalogMH('SectorProveedores');
    },
    sumObject() {
      let sum = this.productsToShow.reduce(
        (prev_value, next_value) => {
          let price = parseFloat(next_value.ItemPriceQty);
          return {
            subTotal:
              (next_value.IsExento == false && next_value.IsNoSujeto == false) 
              ? (
                  ( 
                    this.header.purchaseordertype == 'FI' 
                    || this.header.purchaseordertype == 'DDM'
                  )
                    ? (
                        (this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') 
                          ? (prev_value.subTotal + price / (1 + (parseFloat(this.percentIvaFi)/100)) ) 
                          : (prev_value.subTotal + price / 1.13) 
                      ) 
                      : prev_value.subTotal + price
                ) : prev_value.subTotal,
            iva:
              (next_value.IsExento == false && next_value.IsNoSujeto == false) ?
                (
                  (this.header.purchaseordertype == 'CCF' 
                    || this.header.purchaseordertype == 'NC' 
                    || this.header.purchaseordertype == 'ND' 
                    || this.header.purchaseordertype == 'FI' 
                    || this.header.purchaseordertype == 'DDM' )
                  ? ( (this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') 
                        ? (prev_value.iva + (price - price / (1 + (parseFloat(this.percentIvaFi)/100)))) 
                        : (this.header.purchaseordertype == 'CCF' 
                            || this.header.purchaseordertype == 'NC' 
                            || this.header.purchaseordertype == 'ND')
                          ? (prev_value.iva + (price * 0.13)) 
                          : (prev_value.iva + (price - price / 1.13)) ) 
                  : prev_value.iva + 0
                ) : prev_value.iva + 0,
            ivaret: 0,
            ivaperc: 0,
            nosujeto: next_value.IsNoSujeto ? prev_value.nosujeto + price : prev_value.nosujeto + 0,
            exento: next_value.IsExento ? prev_value.exento + price : prev_value.exento + 0,
            fovial: next_value.IsHidrocarburo ? prev_value.fovial + (parseFloat(next_value.qty) * 0.2) : prev_value.fovial + 0,
            cotrans: next_value.IsHidrocarburo ? prev_value.cotrans + (parseFloat(next_value.qty) * 0.1) : prev_value.cotrans + 0,
          };
        },
        { subTotal: 0, iva: 0, reterenta: 0, ivaret: 0, ivaperc: 0, nosujeto: 0, exento: 0, fovial: 0, cotrans: 0 }
      );   

      let reterenta = 0;
      let Flete = 0;
      let Seguro = 0;
      let sumtmp = parseFloat(sum.subTotal) + parseFloat(sum.iva)
      if (this.header.purchaseordertype == "FNS") {
        for(let i = 0; i < this.productsToShow.length; i++) {
          if(this.productsToShow[i].ItemType == "service") {
            reterenta += parseFloat(parseFloat(this.productsToShow[i].ItemPriceQty) * 0.1)
          }
        }
        sum.reterenta = reterenta
        sum.ivaret = 0
        sum.ivaperc = 0
      }
      else if (this.header.purchaseordertype == "FCF") {
        if (
          (!this.data.LegalAgentRetain && this.BusinessLegalAgentRetain)
        ) {
          if (sumtmp >= 113) {
            sum.ivaret = parseFloat(parseFloat(sum.subTotal) * 0.01)
          } 
          else {
            sum.ivaret = 0;
          }
        }
        else {
          sum.ivaret = 0;
          sum.ivaperc = 0;
        }

        if (this.data.LegalReteRenta) {
          for(let i = 0; i < this.productsToShow.length; i++) {
            if(this.productsToShow[i].ItemType == "service") {
              reterenta += parseFloat((parseFloat(this.productsToShow[i].ItemPriceQty) / 1.13) * 0.1)
            }
          }
        }

        sum.reterenta = reterenta
      }
      else if (this.header.purchaseordertype == "CCF" || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') {
        if (this.data.LegalAgentRetain && !this.BusinessLegalAgentRetain ) {
          if (sumtmp >= 113) {
            sum.ivaperc = parseFloat(parseFloat(sum.subTotal) * 0.01)
          }
          else {
            sum.ivaperc = 0;
          }

          sum.ivaret = 0;
        }
        else {
          sum.ivaperc = 0;
        }

        if (this.BusinessLegalAgentRetain && !this.data.LegalAgentRetain) 
         {
          if (sumtmp >= 113) {
            sum.ivaret = parseFloat(parseFloat(sum.subTotal) * 0.01)
          }
          else {
            sum.ivaret = 0;
          }

          sum.ivaperc = 0;
        }
        else {
          sum.ivaret = 0;
        }

        if (this.data.LegalReteRenta) {
          for(let i = 0; i < this.productsToShow.length; i++) {
            if(this.productsToShow[i].ItemType == "service") {
              if (this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') {
                reterenta += parseFloat((parseFloat(this.productsToShow[i].ItemPriceQty) / (1 + (parseFloat(this.percentIvaFi)/100)) ) * 0.1)
              }
              else {
                reterenta += parseFloat((parseFloat(this.productsToShow[i].ItemPriceQty) / 1.13) * 0.1)
              }
            }
          }
        }

        sum.reterenta = reterenta
      }
      else if (this.header.purchaseordertype == "FE") {
        Flete = parseFloat(this.header.flete || '0')
        Seguro = parseFloat(this.header.seguro || '0') 
        sum.ivaret = 0;
        sum.ivaperc = 0;
        sum.reterenta = 0;
      }
      else {
        sum.ivaret = 0;
        sum.ivaperc = 0;
        sum.reterenta = 0;
      }


      sum.fovial = parseFloat(sum.fovial).toFixed(4);
      sum.cotrans = parseFloat(sum.cotrans).toFixed(4);
      sum.subTotal = parseFloat(sum.subTotal).toFixed(4);
      sum.iva = parseFloat(sum.iva).toFixed(4);
      sum.ivaret = parseFloat(sum.ivaret).toFixed(4);
      sum.ivaperc = parseFloat(sum.ivaperc).toFixed(4);
      sum.reterenta = parseFloat(sum.reterenta).toFixed(4);
      sum.exento = parseFloat(sum.exento).toFixed(4);
      sum.nosujeto = parseFloat(sum.nosujeto).toFixed(4);

      if(this.cotrans > 0) {
        sum.cotrans = parseFloat(this.cotrans).toFixed(4);
      }
      if(this.fovial > 0) {
        sum.fovial = parseFloat(this.fovial).toFixed(4);
      }

      sum.total = parseFloat(
        parseFloat(sum.subTotal) + parseFloat(sum.iva) - parseFloat(sum.reterenta) - parseFloat(sum.ivaret) + parseFloat(sum.ivaperc)
        + parseFloat(sum.exento) + parseFloat(sum.nosujeto) + parseFloat(Flete) + parseFloat(Seguro) + parseFloat(sum.cotrans) + parseFloat(sum.fovial)
      ).toFixed(2);

      return sum;
    },
    ...mapState("providersData", {
      orderDetails: (state) => state.orderDetails,
      order: (state) => state.order,
    }),

    ItemsByName() {
      if (!this.productsToBill) return [];
      const localItems = this.productsToBill.map((item) => {
        return { data: item, value: item.ItemName };
      });

      if (!this.remoteItemsByName.length) {
        return localItems;
      }

      const mergedItems = [...localItems];
      this.remoteItemsByName.forEach((item) => {
        if (!mergedItems.some((entry) => entry?.data?.ID_Item === item.ID_Item)) {
          mergedItems.push({ data: item, value: item.ItemName });
        }
      });

      return mergedItems;
    },
    ItemsByID() {
      if (!this.productsToBill) return [];
      return this.productsToBill.map((item) => {
        return { data: item, value: item.ID_Item };
      });
    },
    ItemsServiceByName() {
      if (!this.servicesToBill) return [];
      return this.servicesToBill.map((item) => {
        return { data: item, value: item.Name || item.NameService}
      })
    },
    ItemsServiceByID() {
      if (!this.servicesToBill) return [];
      return this.servicesToBill.map((item) => {
        return { data: item, value: item.CodeService };
      });
    },
  },
  async mounted() {
    try {
      const userSessionData = JSON.parse(localStorage.getItem("user"));
      this.keymaster = userSessionData.keymaster
      this.requireExpirationDateInventoryPurchases = this.normalizeBusinessFlag(userSessionData?.requireexpirationdateinventorypurchases || 0);
      this.$store.dispatch("rolesUser/getAllRoles");
      let idbusiness =
        JSON.parse(localStorage.getItem("user")).businessid || "";
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
      let user = JSON.parse(localStorage.getItem("user")).id || "";

      this.form.ID_Business = idbusiness;
      this.form.ID_Branch = idbranch || "";
      this.form.ID_User_Insert = user;

      this.filterProducts.business = idbusiness;
      this.filterProducts.branch = idbranch;

      this.filterProducts.provider = this.data.ID_Provider;
      if(this.noProviderFilter.includes(this.keymaster)){
        this.noProvider = true;
      }
      this.filterProducts.noProvider = this.noProvider;
      this.getAllWarehouses();

      this.getCatalogTypedocument();

      await this.$API.products.priceList().then((response) => {
        response.map((item, index) => {
          Vue.set(this.priceList, index + 1, item);
        });
      });

      this.search = { ...this.filterProducts };
      
      // not for "MANUEL ENRIQUE PINEDA MARTINEZ", "RECINOS BOLAINES, GUADALUPE"
      if (!this.noProvider) {
        await this.getProducts();
      }
      await this.getAllServices();
      
      this.header = {
        purchaseordername: this.data.ProviderName,
        purchaseorderemail: this.data.ProviderEmail,
        purchaseordermobile: this.data.ProviderMobileNumber,
        purchaseorderphone: this.data.ProviderPhone,
        purchaseordercountry: this.data.ProviderCountry,
        purchaseordercontactmobile: this.data.ProviderContactMobile,
        purchaseordercontactphone: this.data.ProviderContactPhone,
        purchaseordercontactemail: this.data.ProviderContactEmail,
        purchaseorderstate: this.data.ProviderState,
        purchaseordercity: this.data.ProviderCity,
        purchaseordernotes: this.data.Notes,
        purchaseordercontactname: this.data.ProviderContactName,
        purchaseorderaddress: this.data.ProviderAddress,
        purchaseordernrc: this.data.ProviderLegalNRC,
        purchaseordernit: this.data.ProviderLegalNIT,
        purchaseordersector: this.data.ProviderLegalSector,
        purchaseorderentity: this.data.ProviderLegalEntity,
        purchaseordertaxpayersize: this.data.ProviderLegalTaxPayerSize,
        purchaseorderisnontaxable: this.data.ProviderLegalIsNonTaxable
          ? this.data.ProviderLegalIsNonTaxable
          : "",
        subtotal: this.sumObject.subTotal,
        iva: this.sumObject.iva,
        incometax: this.sumObject.nontaxable,
        ivaret: this.sumObject.ivaret,
        total: this.sumObject.total,
        // purchaseordertotalinletters: this.totalInSpanish(),
        provider: this.data.ID_Provider || "",
        // warehouse: this.state.warehouseEntry,
        itemcurrency: "$",
        idbranch: this.form.ID_Branch,
        idbusiness: this.form.ID_Business,
        purchaseinvoicedate: this.purchaseinvoicedate,
        purchaseorderdate: this.purchaseorderdate,
        CustomCSVPeriodFlag: this.header.CustomCSVPeriodFlag,
        CustomCSVPeriodMonth: this.header.CustomCSVPeriodMonth,
        CustomCSVPeriodYear: this.header.CustomCSVPeriodYear,
        ClasificationRent: '1'
      };

      if (this.orderDetails != null) {
        this.detailsToshow = true;
        this.getAllWarehouses();
        this.header.days =
          this.order.days != undefined || this.order.days != null
            ? this.order.days
            : "30 Dias";
        this.header.invoiceStatus = this.order.InvoiceState
          ? this.order.InvoiceState
          : null;
        this.header.paymentMethod = this.order.paymenMethod
          ? this.order.paymenMethod
          : null;
        this.header.documenttype = this.order.PurchaseDocumentType
          ? `${this.order.PurchaseDocumentType}`
          : null;
      } else {
        //await this.getPurchaseId();
        this.header.days = "30 Dias";
      }

      this.getInfoBranch();
    } catch (error) {
      console.log(error);
    }
    // Get barcodes
    //this.getAllBarCodes(this.data.ID_Provider);

    this.calculateSummaryBoxPosition();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.calculateSummaryBoxPosition);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.calculateSummaryBoxPosition);
  },
  methods: {
    getSelectedGlobalWarehouse() {
      if (this.globalWarehouse == null || this.globalWarehouse === "") {
        return null;
      }

      return this.warehouses.find(
        (warehouse) => warehouse.ID_Warehouse == this.globalWarehouse
      ) || null;
    },
    normalizeBusinessFlag(value) {
      return isTruthyFlag(value);
    },
    findItemWithoutRequiredExpirationDate(items) {
      return items.find((item) => {
        return this.requireExpirationDateInventoryPurchases
          && item.ItemType != "service"
          && !item.ProductWithoutExpirationDate
          && !item.ExpirationDate;
      });
    },
    validateRequiredExpirationDates() {
      const item = this.findItemWithoutRequiredExpirationDate(this.productsToShow);

      if (!item) return true;

      this.showAlert(
        "warning",
        "Advertencia",
        `El producto "${item.ItemName}" con id "${item.ID_Item}" requiere fecha de vencimiento.`
      );
      return false;
    },
    getWarehouseWithDefault(warehouse) {
      if (warehouse) return warehouse
      return this.warehouses.find((el) => el.ID_Warehouse === this.globalWarehouse)
    },
    getWarehouseByItem(item) {
      const warehouse = this.productsToBill.find(el => el.ID_Item == item.ID_Item)
      return this.getWarehouseWithDefault(warehouse)
    },
    setCustomCSVPeriod(val){
      this.header.CustomCSVPeriodFlag = val
    },
    setCustomCSVPeriodYear(val){
      this.header.CustomCSVPeriodYear = val
    },
    setCustomCSVPeriodMonth(val){
      this.header.CustomCSVPeriodMonth = val
    },
    printPosFaComponent(options, DOM = document.body) {

      const printPosFaInstance = new printPosFaConstructor({
        propsData: {
          dataProps: options,
        },
      });
      printPosFaInstance.vm = printPosFaInstance.$mount();
      const dom = DOM;
      dom.appendChild(printPosFaInstance.vm.$el);
      return printPosFaInstance.vm;
    },
    addValidToTypeInvoice(calculateIva = false) {
      if (this.header.purchaseordertype == "FNS") {
        this.header.documenttype = this.documentOptions[1].value;
        this.header.purchaselegalinvoicenumber = null;
        this.invoiceStatus = ["Cancelada", "Crédito"];
        this.header.invoiceStatus = this.invoiceStatus[0];
      } else {
        this.invoiceStatus = ["Pendiente de pago", "Cancelada", "Crédito"];
      }

      if (calculateIva) {
        if (this.header.purchaseordertype == 'CCF' || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') {
          this.checkboxIva = true
          this.productsToShow.forEach((item) => {
            Vue.set(item, "iva", true);
          });
        }
        else {
          this.checkboxIva = false
          this.productsToShow.forEach((item) => {
            Vue.set(item, "iva", false);
          });
        }
      }

      this.header = { ...this.header }
    },
    assingWarehouseGlobally() {
      if (this.globalWarehouse == null || this.globalWarehouse == "") {
        this.showAlert(
          "warning",
          "Advertencia",
          "Por favor seleccionar un almacén."
        );
      } else {
        let found = this.warehouses.find((wh) => wh.ID_Warehouse == this.globalWarehouse);
        this.productsToShow = this.productsToShow.map(product => ({
          ...product,
          Warehouse: found.Warehouse,
          ID_Warehouse: found.ID_Warehouse
        }));
      }
    },
    getBarCode(ID_Provider, barcode) {
      this.loading = true;
      this.$API.inventoryitemsbarcodes
        .getBarCodeProvidersById({ ID_Provider, barcode , noProvider: this.noProvider})
        .then((data) => {
          this.barCodeToFind = data;
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
          if (
            this.barCodeToFind &&
            this.barCodeToFind.ID_Item &&
            typeof this.barCodeToFind.ID_Item === "string"
          ) {
            this.addByBarCode();
          } else {
            this.showAlert(
              "danger",
              "Advertencia",
              "Código de barra no válido."
            );
          }

          this.selectedBarCode = ""
        });
    },
    getAllBarCodes(ID_Provider) {
      //Funcion innecesaria: no se utilizara.
      this.$API.inventoryitemsbarcodes
        .getAllBarCodes(ID_Provider)
        .then((data) => {
          this.barCodes = data;
          //console.log('barcodes', this.barCodes);
        })
        .catch((error) => console.log(error));
        
      //Función para que traiga la vista con todos los ID ITEM del proveedor seleccionado 
      this.$API.inventoryitemsbarcodes.getInventoryStockByProvider(ID_Provider)
        .then((data) => {
          this.allProvidersInventoryItems = data;
          //console.log('all items provider', this.allProvidersInventoryItems);
        })
        .catch((error) => console.log(error));
    },
    clearFilter() {
      this.productsFiltered = false;
    },
    filterHandler(response) {
      this.productsFiltered = true;
      this.productsToShowFiltered = response;
    },
    getCatalogTypedocument() {
      this.$API.catalogtypedocument
        .getCatalogTypeDocumentForProvider()
        .then(({ data }) => {
          this.catalogTypedocument = data;
        });
    },
    handleFileUpload(event) {
      // Get the selected file from the event
      this.selectedFile = event;
    },
    importJsonData() {
      if (this.selectedFile) {
        const reader = new FileReader();
        reader.onload = async () => {
            try {
              this.jsonData = parseJsonRelaxedCanonical(reader.result);
              if (!this.jsonData.identificacion || !this.jsonData.resumen) {
                throw new Error("Formato no válido del JSON.");
              }
              this.showJsonImport = false;
              const canContinue = await this.validateGeneratedCodeDuplicates({ ...this.jsonData });
              if (!canContinue) {
                this.clearJsonData();
                return;
              }
              if(!this.providerMatches({ ...this.jsonData })) {
                const result = await this.showAlertDoc()
                if(!result) {
                  this.clearJsonData();
                  return;
                }
              }

            this.showDataImported({ ...this.jsonData });
          } 
          catch (error) {
            this.showJsonImport = false;
            this.showAlert("warning", "Advertencia", `Ocurrio el siguiente error al leer el archivo JSON: ${error.message}`);
          }
        };
        reader.readAsText(this.selectedFile);
      }
    },
    showDataImported({ identificacion, resumen, documentoRelacionado }) {
      this.$nextTick(() => {
        this.$refs["inputdatepicker"].dateFormatted = formatDate(
          identificacion.fecEmi
        );
        this.$refs["inputdatepicker"].date = identificacion.fecEmi;
      });
      this.showInfoPurchase = true;
      this.header.purchaseordertype = this.catalogTypedocument.find(
        ({ code }) => code === identificacion.tipoDte
      ).value;
      this.header.documenttype = this.documentOptions[1].value;
      this.header.purchaselegalinvoicenumber = identificacion.codigoGeneracion;
      this.header.numerocontrol = identificacion?.numeroControl || null;
      
      // Extraer selloRecibido del JSON
      const jsonDataFull = arguments[0];
      this.header.selloRecibido = findSelloRecibido(jsonDataFull);
      
      // Extraer número de documento relacionado si existe
      if (documentoRelacionado && documentoRelacionado.length > 0) {
        this.header.NumeroDocumentoRelacionado = documentoRelacionado[0].numeroDocumento || '';
      }
      
      switch (resumen.condicionOperacion) {
        case 1:
          // cancelada
          this.header.invoiceStatus = this.invoiceStatus[1];
          break;
        case 2:
          // credito
          this.header.invoiceStatus = this.invoiceStatus[3];
          break;
        default:
          // pendiente de pago
          this.header.invoiceStatus = this.invoiceStatus[0];
          break;
      }
      this.purchaseinvoicedate = formatDate(identificacion.fecEmi);
    },
    normalizeGenerationCode(value) {
      if (value === null || value === undefined) {
        return null;
      }

      const normalized = String(value).trim().replace(/[\s-]+/g, "");
      return normalized.length > 0 ? normalized : null;
    },
    getGenerationCodeFromJson(data) {
      return this.normalizeGenerationCode(data?.identificacion?.codigoGeneracion);
    },
    groupDuplicateDocuments(duplicates) {
      const grouped = new Map();

      duplicates.forEach((duplicate) => {
        const code = this.normalizeGenerationCode(duplicate?.codigoGeneracion);
        if (!code) {
          return;
        }

        if (!grouped.has(code)) {
          grouped.set(code, new Set());
        }

        const sourceLabel = duplicate?.sourceLabel
          || (duplicate?.source === 'purchase' ? 'Compras de inventario' : 'Gastos');
        grouped.get(code).add(sourceLabel);
      });

      return Array.from(grouped.entries()).map(([codigoGeneracion, labels]) => ({
        codigoGeneracion,
        sourceLabels: Array.from(labels),
      }));
    },
    buildDuplicateBody(duplicates) {
      const groupedDuplicates = this.groupDuplicateDocuments(duplicates);

      const duplicateLines = groupedDuplicates
        .map(({ sourceLabels }) => {
          const labelsText = sourceLabels.join(' y ');
          return `El documento ya fue agregado en ${labelsText}.`;
        });

      duplicateLines.push('¿Desea continuar de todas formas?');

      return duplicateLines.join('<br>');
    },
    getTrimmedValue(value) {
      return String(value === null || value === undefined ? "" : value).trim();
    },
    buildProductLookupMap(items = []) {
      const lookup = new Map();

      items.forEach((item) => {
        [
          item?.ID_Item,
          item?.BarCode,
          item?.PrincipalBarCode,
          item?.ItemBarCode,
          item?.CodigoAlterno,
        ].forEach((code) => {
          const normalizedCode = this.normalizeProductCode(code);
          if (normalizedCode && !lookup.has(normalizedCode)) {
            lookup.set(normalizedCode, item);
          }
        });
      });

      return lookup;
    },
    normalizeProductCode(value) {
      return this.getTrimmedValue(value).replace(/[\s-]+/g, "");
    },
    async fetchProductsByCodes(codes) {
      if (!Array.isArray(codes) || !codes.length) {
        return [];
      }

      try {
        const response = await this.$API.products.getProductsToBillForPurchaseOrdersByCodes({
          ...this.filterProducts,
          codes,
        });

        return Array.isArray(response) ? response : [];
      } catch (error) {
        console.warn("No fue posible resolver los productos en lote:", error);
        return [];
      }
    },
    async validateGeneratedCodeDuplicates(data) {
      const codigoGeneracion = this.getGenerationCodeFromJson(data);

      if (!codigoGeneracion) {
        return true;
      }

      try {
        const response = await this.$API.accountingexpensesentry.verifyGenerationCodes({
          codigosGeneracion: [codigoGeneracion],
        });

        const duplicates = Array.isArray(response?.duplicates) ? response.duplicates : [];

        if (duplicates.length === 0) {
          return true;
        }

        const duplicateBody = this.buildDuplicateBody(duplicates);

        return await new Promise((resolve) => {
          this.alert.onAccept = () => {
            this.alert.onAccept = null;
            this.alert.onCancel = null;
            resolve(true);
          };
          this.alert.onCancel = () => {
            this.alert.onAccept = null;
            this.alert.onCancel = null;
            resolve(false);
          };
          this.showAlert(
            "questionDangerHtml",
            "Advertencia",
            duplicateBody
          );
        });
      } catch (error) {
        console.error(error);
        this.showAlert(
          "warning",
          "Advertencia",
          "No fue posible validar si el documento ya existe en el sistema."
        );
        return false;
      }
    },
    // Funciones para manejar el procesamiento del JSON
    
    handleFileChange(file) {
      this.selectedFile = null;
      this.selectedFile = file ? file : null;      
    },
    applyGlobalDiscount() {
      if (!this.globalDiscount || this.globalDiscount <= 0) {
        return;
      }

      let totalItems = 0;

      this.productsToShow.forEach(p => {
        if (p.applyGlobalDiscount === true && parseFloat(p.price)) {
          totalItems += parseFloat(p.qty) || 0;
        }
      });
      
      let globalUnitDiscount = this.globalDiscount / totalItems;
      globalUnitDiscount = parseFloat(globalUnitDiscount.toFixed(4));

      for (const item of this.productsToShow) {
        if (item.noGlobalDicountPrice === null || item.noGlobalDicountPrice === undefined) {
          item.noGlobalDicountPrice = parseFloat(item.ItemNewPrice) || 0.0;
        }

        let newPrice = parseFloat(item.noGlobalDicountPrice) || 0.0;

        if (item.applyGlobalDiscount) {
          newPrice -= globalUnitDiscount;
        }

        item.price = parseFloat(newPrice.toFixed(4));
        item.priceFixedDecimal = newPrice.toFixed(2)
        item.ItemNewPrice = item.price;    
        
        this.productsToShow = [...this.productsToShow]
      }
    },
    applyGlobalDiscountToAll() {
      this.productsToShow.forEach(p => {
        p.applyGlobalDiscount = true;
      });
      
      this.applyGlobalDiscount();
    },
    removeGlobalDiscountFromAll() {
      this.productsToShow.forEach(p => {
        p.applyGlobalDiscount = false;
      });
      
      console.log('removeFromAll')
      this.applyGlobalDiscount();
    },
    onUnitCostChange (value, data) {
      data.price = parseFloat(value) || 0.0;
      data.priceFixedDecimal = data.price.toFixed(2);
      data.noGlobalDicountPrice = data.price;
    },
    onApplyGlobalDiscountChange() {
      this.applyGlobalDiscount();
    },
    async processJsonData() {
      //this.showJsonLoading = true;
      //this.loadingJson = true;
      if (this.selectedFile && this.selectedFile.type == 'application/json') {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            const data = parseJsonRelaxedCanonical(e.target.result);
            this.jsonData = data;
            if (!this.jsonData.identificacion || !this.jsonData.resumen) {
              throw new Error("Formato no válido del JSON.");
            }
            this.showJsonImport2 = false;
            const canContinue = await this.validateGeneratedCodeDuplicates({ ...this.jsonData });
            if (!canContinue) {
              this.clearJsonData();
              return;
            }
            if(!this.providerMatches({ ...this.jsonData })) {
              const result = await this.showAlertDoc()
              if(!result) {
                this.clearJsonData();
                return;
              }
            }
            await this.handleJsonDataHeader({ ...this.jsonData });
            await this.waitForPaint();
            await this.handleJsonDataItems({ ...this.jsonData });
           
          } 
          catch (error) {
            console.log(error);
            this.clearJsonData();
            this.showJsonImport2 = false;
            this.showAlert("warning", "Advertencia", `Ocurrio el siguiente error al leer el archivo JSON: ${error.message}`);
          } 
        };
        reader.readAsText(this.selectedFile);
      } else {
        this.showJsonImport2 = false;
        this.showAlert("warning", "Advertencia", `Por favor, selecciona un archivo JSON.`);
      }
    },
    //Validacion de NIT proveedor <-> JSON
    providerMatches(data) {
      const providerInfo = data?.emisor?.nit;
      const providerNit = this.data.ProviderLegalNIT;
      console.log({data, providerInfo, providerNit});
      if (!providerInfo || !providerNit) 
        return true;
      console.log(providerInfo == providerNit);
      
      return providerInfo == providerNit;
    },
    async handleJsonDataHeader(data) {
      // Procesando datos de la factura
      this.showInfoPurchase = true;
      const invoicedate = formatDate(data.identificacion.fecEmi);
      
      this.header.purchaseordertype = this.catalogTypedocument.find(({ code }) => code === data.identificacion.tipoDte).value;
      this.header.documenttype = this.documentOptions[1].value;
      this.header.purchaselegalinvoicenumber = data.identificacion.codigoGeneracion;
      this.header.numerocontrol = data.identificacion.numeroControl || '';
      
      // Extraer selloRecibido del JSON
      this.header.selloRecibido = findSelloRecibido(data);
      
      // Extraer número de documento relacionado si existe
      if (data.documentoRelacionado && data.documentoRelacionado.length > 0) {
        this.header.NumeroDocumentoRelacionado = data.documentoRelacionado[0].numeroDocumento || '';
      }

      this.globalDiscount = parseFloat(data.resumen.totalDescu) || 0.0;

      await this.$nextTick();
      this.purchaseinvoicedate = invoicedate;
      this.$refs["inputdatepicker"].date = data.identificacion.fecEmi;
      this.$refs["inputdatepicker"].dateFormatted = invoicedate;
      switch (data.resumen.condicionOperacion) {
        case 1:
          // cancelada
          this.header.invoiceStatus = this.invoiceStatus[1];
          break;
        case 2:
          // credito
          this.header.invoiceStatus = this.invoiceStatus[3];
          break;
        default:
          // pendiente de pago
          this.header.invoiceStatus = this.invoiceStatus[0];
          break;
      }
      //console.log(this.header);
    },
    waitForPaint() {
      return new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => resolve());
        });
      });
    },
    async handleJsonDataItems(data) {
      this.currentImportSource = 'json';
      this.pendingExcelSkippedRows = [];
      this.productsToLoad = [];
      this.showJsonLoading = true;
      this.jsonProcessing = true;
      

      try {
        const items = Array.isArray(data?.cuerpoDocumento) ? data.cuerpoDocumento : [];
        const codes = Array.from(
          new Set(
            items
              .map((item) => this.getTrimmedValue(item.codigo))
              .filter(Boolean)
          )
        );
        const remoteProducts = await this.fetchProductsByCodes(codes);
        const remoteLookup = this.buildProductLookupMap(remoteProducts);
        const array = [];

        for (const item of items) {
          const itemCode = this.getTrimmedValue(item.codigo);
          const normalizedItemCode = this.normalizeProductCode(item.codigo);
          const existingItem =
            remoteLookup.get(itemCode) ||
            remoteLookup.get(normalizedItemCode) ||
            null;

          const quantity = parseFloat(item.cantidad) || 0;
          const totalItemDiscount = parseFloat(item.montoDescu) || 0.0;

          let price = parseFloat(item.precioUni) || 0.0;

          if (quantity > 0 && price > 0 && totalItemDiscount > 0) {
            if (this.globalDiscount > 0) {
              this.globalDiscount = 0.0;
            }

            const unitDiscount = totalItemDiscount / quantity;
            price -= unitDiscount;
          }
          
          if(!existingItem){
            array.push({
              ...item,
              code: itemCode,
              description: item.descripcion,
              quantity: item.cantidad,
              price,
              priceFixedDecimal: price.toFixed(2),
              error: {
                code: "UNKNOW_ID_ITEM",
                message: 'El codigo cargado no se encuentra asociado a ningun producto',
              },
              ID_Business: JSON.parse(localStorage.getItem("user")).businessid,
              ID_Branch: JSON.parse(localStorage.getItem("user")).branch,
            });
          }
          else {
            const warehouse = existingItem.inventory_warehouse || this.getWarehouseByItem(existingItem) || {};
            array.push({
              ...item,
              code: itemCode,
              description: item.descripcion,
              quantity: item.cantidad,
              noGlobalDicountPrice: price,
              price,
              priceFixedDecimal: price.toFixed(2),
              id: existingItem.ID_Item,
              warehouse: warehouse.Warehouse || null,
              ID_Warehouse: warehouse.ID_Warehouse || null,
              IsHidrocarburo: existingItem.IsHidrocarburo,
              error: {
                code: null,
                message: '',
              },
              ID_Business: existingItem.ID_Business || JSON.parse(localStorage.getItem("user")).businessid,
              ID_Branch: existingItem.ID_Branch || JSON.parse(localStorage.getItem("user")).branch,
            });
          }
        }
        this.productsToLoad = array;

        if(data.resumen.tributos && data.resumen.tributos.length) {
          data.resumen.tributos.forEach((item) => {
            if(item.codigo === "C8") {
              this.cotrans = item.valor.toFixed(2);
              this.showFuelTaxes = true;
            }
            if(item.codigo === "D1") {
              this.fovial = item.valor.toFixed(2);
              this.showFuelTaxes = true;
            }
          });
        }
      } finally {
        this.jsonProcessing = false;
      }
    },
    handleJsonDataFixes(data) {
      const { code } = this.selectedProduct;
      const warehouse = this.getWarehouseWithDefault(data.inventory_warehouse)

      this.productsToLoad.forEach((item) => {
        if (item.code === code) {
          item.id = data.ID_Item;
          item.warehouse = warehouse.Warehouse;
          item.ID_Warehouse = warehouse.ID_Warehouse;
          item.error = {
            code: null,
            message: ''
          };
          item.newBarcode = true;
        }
      });
      
      this.showJsonUpdate = false;
      this.searchQueryBarCodes = '';
      this.filteredBarCodes = this.allProvidersInventoryItems;
    },
    buildProductsToShowFromExcelData(items) {
      return items.map((item) => {
        const itemId = item.id || item.ID_Item;
        const selectedGlobalWarehouse = this.getSelectedGlobalWarehouse();
        const providerItem =
          this.productsToBill.find((product) => product.ID_Item == itemId) ||
          this.allProvidersInventoryItems.find((product) => product.ID_Item == itemId) ||
          {};
        const warehouse =
          (selectedGlobalWarehouse && {
            Warehouse: selectedGlobalWarehouse.Warehouse,
            ID_Warehouse: selectedGlobalWarehouse.ID_Warehouse,
          }) ||
          (item.ID_Warehouse && {
            Warehouse: item.warehouse || item.Warehouse,
            ID_Warehouse: item.ID_Warehouse,
          }) ||
          this.getWarehouseByItem({ ID_Item: itemId }) ||
          this.getWarehouseWithDefault(providerItem.inventory_warehouse) ||
          {};
        const price = parseFloat(item.price ?? item.ItemNewPrice) || 0.0;
        const quantity = parseFloat(item.quantity ?? item.qty) || 0;

        return {
          ...providerItem,
          ...item,
          ID_Item: itemId,
          BarCode: item.BarCode || item.code || providerItem.BarCode || "",
          ItemName:
            item.ItemName ||
            item.description ||
            providerItem.ItemName ||
            providerItem.ItemComercialName ||
            "",
          qty: quantity,
          cotrans: item.cotrans || 0,
          fovial: item.fovial || 0,
          price,
          priceFixedDecimal: price.toFixed(2),
          noGlobalDicountPrice:
            parseFloat(item.noGlobalDicountPrice ?? item.price ?? item.ItemNewPrice) || 0.0,
          ItemNewPrice: price,
          Warehouse: item.warehouse || item.Warehouse || warehouse.Warehouse || null,
          ID_Warehouse: item.ID_Warehouse || warehouse.ID_Warehouse || null,
          ItemPriceQty: 0,
          IsExento: this.getImportedTaxFlag(item, "IsExento", "ventaExenta"),
          IsNoSujeto: this.getImportedTaxFlag(item, "IsNoSujeto", "ventaNoSuj"),
          iva: this.isTaxCredit(),
        };
      });
    },
    getImportedTaxFlag(item, currentKey, legacyKey) {
      if (typeof item[currentKey] === "boolean") {
        return item[currentKey];
      }

      return item[legacyKey] == 0 ? false : !!item[legacyKey];
    },
    handleJsonDataLoad() {
      try {
        //console.log(this.productsToLoad);
        const productsToAdd = this.productsToLoad.filter(item => !item.error.code);
        const productsCantContinue = this.productsToLoad.filter(item => item.error.code);
        if(!productsToAdd.length) {
          throw new Error ('No existen productos validos para procesar. Revise los datos del archivo JSON y vuelve a intentarlo.')
        }
        
        const products = productsToAdd.map((item) => {
          //Función que inserta el codigo de barras al id item en la tabla inventory_items_barcodes
          if(item.newBarcode) {
            this.handleCreateBarCode({ 
              BarCode: item.code, 
              ID_Item: item.id,
              ID_Branch: this.header.idbranch,
              ID_Business: this.header.idbusiness,
            });
          }

          return {
            ...item,
            ID_Item: item.id,
            BarCode: item.code,
            ItemName: item.description,
            qty: item.quantity,
            cotrans: 0,
            fovial: 0,
            ItemNewPrice: item.price,
            Warehouse: item.warehouse,
            ItemPriceQty: 0,
            //ItemPriceQty: ItemPriceQty,
            IsExento: item.ventaExenta == 0 ? false : true,
            IsNoSujeto: item.ventaNoSuj == 0 ? false : true,
            iva: (this.header.purchaseordertype == 'CCF' || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? true : false,
          }
        });

        this.productsToShow = products;
        //console.log(this.productsToShow);
        this.showJsonLoading = false;
        if(productsCantContinue.length) {
          this.showAlert("warning", "Carga completada parcialmente", `Algunos productos importados no se pudieron cargar debido a la existencia errores en la información. Productos con errores: ${productsCantContinue.length}.`);
        } else {
          this.showAlert("success", "Carga completada exitosamente", 'Todos los productos importados del JSON fueron cargados con exito.');
        }
      }
      catch (error) {
        this.clearJsonData();
        this.showJsonLoading = false;
        this.showAlert("warning", "Advertencia", error.message);
      }
    },
    async handleCreateBarCode(data) {
      await this.$API.inventoryitemsbarcodes.saveBarCode(data)
        .then((res) => {
          return res.data;
        })
        .catch((error) => console.log(error));
    },
    onClickErrorJsonData(data) {
      this.selectedProduct = data;
      this.showJsonUpdate = true;
    },
    openQuantityConversionFromMain(product, index) {
      const currentPrice = parseFloat(product.price) || 0;
      const currentQuantity = parseFloat(product.qty) || 0;
      this.conversionData = {
        productIndex: index,
        product: product,
        productCode: product.ID_Item,
        productDescription: product.ItemName || product.Name || product.NameService,
        originalQuantity: currentQuantity,
        originalPrice: currentPrice,
        packQuantity: currentQuantity,
        conversionFactor: 1,
        pricePerPack: currentPrice,
        totalQuantity: currentQuantity,
        totalPrice: currentPrice * currentQuantity,
        unitPrice: currentPrice
      };
      this.showQuantityConversion = true;
    },
    calculateConversion() {
      const packQty = parseFloat(this.conversionData.packQuantity) || 0;
      const factor = parseFloat(this.conversionData.conversionFactor) || 0;
      const pricePerPack = parseFloat(this.conversionData.pricePerPack) || 0;
      
      // Calcular total de unidades
      this.conversionData.totalQuantity = packQty * factor;
      
      // Calcular precio unitario: precio por caja / unidades por caja
      if (factor > 0) {
        this.conversionData.unitPrice = pricePerPack / factor;
      } else {
        this.conversionData.unitPrice = 0;
      }
      
      // Calcular precio total
      this.conversionData.totalPrice = packQty * pricePerPack;
    },
    applyQuantityConversion() {
      if (this.conversionData.totalQuantity <= 0) {
        this.showAlert(
          'warning',
          'Cantidad inválida',
          'La cantidad total debe ser mayor a 0'
        );
        return;
      }
      
      const product = this.conversionData.product;
      if (product) {
        product.qty = parseFloat(this.conversionData.totalQuantity.toFixed(5));
        product.price = parseFloat(this.conversionData.unitPrice.toFixed(5));
        product.ItemNewPrice = parseFloat(this.conversionData.unitPrice.toFixed(5));
        product.priceFixedDecimal = product.price.toFixed(5);
        product.noGlobalDicountPrice = product.price;
        
        // Recalcular el total del producto
        product.ItemPriceQty = (product.qty * product.price).toFixed(5);
        
        this.showAlert(
          'success',
          'Conversión aplicada',
          `Se actualizó la cantidad a ${product.qty} unidades con precio unitario de $${product.price.toFixed(4)}`
        );
      }
      
      this.closeQuantityConversion();
    },
    closeQuantityConversion() {
      this.showQuantityConversion = false;
      this.conversionData = {
        productIndex: null,
        product: null,
        productCode: null,
        productDescription: null,
        originalQuantity: 0,
        originalPrice: 0,
        packQuantity: 1,
        conversionFactor: 1,
        pricePerPack: 0,
        totalQuantity: 0,
        totalPrice: 0,
        unitPrice: 0
      };
    },
    //Función para filtrar barcodes existentes
   async applyGeneralFilterBarCodes() {
      const query = this.searchQueryBarCodes?.toLowerCase();
      let data = await this.searchProducts(query);    
      this.filteredBarCodes = Array.isArray(data) ? data : [];
      /*
      this.allProvidersInventoryItems.filter((item) => {
        return (
          item.BarCode?.toLowerCase().includes(query) ||
          item.ID_Item?.toString().toLowerCase().includes(query) ||
          item.ItemName?.toLowerCase().includes(query)
        );
      });
      */
    },
    // Métodos para el componente JsonProductManager
    onProductLinked({ product }) {
      console.log('Producto vinculado:', product);
      
      // Actualizar el producto en productsToLoad
      const index = this.productsToLoad.findIndex(p => p.code === product.code);
      if (index !== -1) {
        this.$set(this.productsToLoad, index, product);
      }

      // Crear código de barras si es necesario
      if (product.newBarcode) {
        this.handleCreateBarCode({
          BarCode: product.code,
          ID_Item: product.id,
          ID_Branch: this.header.idbranch,
          ID_Business: this.header.idbusiness
        });
      }
    },

    onProductUpdated(product) {
      console.log('Producto actualizado:', product);
      
      const index = this.productsToLoad.findIndex(p => p.code === product.code);
      if (index !== -1) {
        this.$set(this.productsToLoad, index, product);
      }
    },

    onLoadProducts({ validProducts, invalidProducts }) {
      try {
        if (this.currentImportSource === 'excel') {
          const importedProducts = this.buildProductsToShowFromExcelData(validProducts);
          this.productsToShow = [...this.productsToShow, ...importedProducts];

          const skippedCount = this.pendingExcelSkippedRows.length;
          const totalErrors = invalidProducts.length + skippedCount;

          if (totalErrors > 0) {
            const detailErrors = [
              ...invalidProducts.slice(0, 2).map((row) => row.error.message),
              ...this.pendingExcelSkippedRows.slice(0, 2).map((row) => row.error.message),
            ].join(" ");

            this.showAlert(
              'warning',
              'Carga completada parcialmente',
              `Se agregaron ${importedProducts.length} producto(s) al detalle. Filas con errores: ${totalErrors}. ${detailErrors}`.trim()
            );
          } else {
            this.showAlert(
              'success',
              'Carga completada exitosamente',
              `Se agregaron ${importedProducts.length} producto(s) al detalle de la compra.`
            );
          }

          this.pendingExcelSkippedRows = [];
          this.currentImportSource = null;
          return;
        }

        // Mapear productos válidos al formato correcto
        const products = validProducts.map((item) => {
          // Crear código de barras si es necesario
          if (item.newBarcode) {
            this.handleCreateBarCode({
              BarCode: item.code,
              ID_Item: item.id,
              ID_Branch: this.header.idbranch,
              ID_Business: this.header.idbusiness
            });
          }

          return {
            ...item,
            ID_Item: item.id,
            BarCode: item.code,
            ItemName: item.description,
            qty: item.quantity,
            cotrans: 0,
            fovial: 0,
            ItemNewPrice: item.price,
            Warehouse: item.warehouse,
            ItemPriceQty: 0,
            IsExento: item.ventaExenta == 0 ? false : true,
            IsNoSujeto: item.ventaNoSuj == 0 ? false : true,
            iva: this.isTaxCredit()
          };
        });

        // Asignar a productsToShow
        this.productsToShow = products;

        // Mostrar alerta según el resultado
        if (invalidProducts.length > 0) {
          this.showAlert(
            'warning',
            'Carga completada parcialmente',
            `Algunos productos no se pudieron cargar. Productos con errores: ${invalidProducts.length}.`
          );
        } else {
          this.showAlert(
            'success',
            'Carga completada exitosamente',
            'Todos los productos fueron cargados con éxito.'
          );
        }
      } catch (error) {
        this.showAlert(
          'danger',
          'Error al cargar productos',
          error.message
        );
      }
    },
    handleDetailImport({ productsToLoad, skippedRows }) {
      const rowsToLoad = Array.isArray(productsToLoad) ? productsToLoad : [];
      const rowsSkipped = Array.isArray(skippedRows) ? skippedRows : [];
      const duplicateRows = rowsToLoad.filter(
        (row) => row.error?.code === 'DUPLICATE_ALTERNATE_CODE'
      );

      if (!rowsToLoad.length) {
        const firstError = rowsSkipped[0]?.error?.message || 'No se encontraron filas válidas para importar.';
        this.showAlert('warning', 'Advertencia', firstError);
        return;
      }

      if (duplicateRows.length) {
        this.showAlert(
          'warning',
          'Códigos alternos duplicados',
          `Se detectaron ${duplicateRows.length} fila(s) con código alterno duplicado. Puede revisarlas en "Procesando productos del proveedor".`
        );
      }

      this.pendingExcelSkippedRows = rowsSkipped;
      this.currentImportSource = 'excel';
      this.productsToLoad = rowsToLoad;
      this.showExcelImport = false;
      this.showJsonLoading = true;
    },
    handleExcelInvoiceTypeChange(value) {
      this.header.purchaseordertype = value;
    },
    downloadPurchaseImportTemplate() {
      downloadPurchaseDetailImportTemplate();
    },

    handleAlertFromComponent({ type, title, message }) {
      this.showAlert(type, title, message);
    },

    openProductCreationDialog({ code, description }) {
      // Cambiar a la pestaña de productos del proveedor
      this.$store.commit('providersData/changeView', 'tab-4');
      
      this.showAlert(
        'info',
        'Crear producto',
        `Puedes crear el producto "${description}" (código: ${code}) desde la pestaña de PRODUCTOS.`
      );
    },

    async onCreateProducts({ products }) {
      try {
        let createdCount = 0;
        let errorCount = 0;
        let unconfirmedCount = 0;
        let syncWarning = '';

        for (const product of products) {
          try {
            // Preparar datos del producto usando los valores editados inline
            const newProductData = {
              itemname: product.description || '',
              itemcomercialname: product.description || '',
              itemprice: parseFloat(product.price) || 0.01, // Enviar 0.01 si el precio es 0 para evitar || ""
              suggestedPrice: parseFloat(product.suggestedPrice) || 0.01,
              itemtype: product.itemType || 'No Consumible',
              idprovider: this.data.ID_Provider,
              idbusiness: this.header.idbusiness,
              idbranch: this.header.idbranch,
              isglobalbranch: 0,
              itemdeclarationtype: 1, // Enviar 1 en lugar de 0 para evitar conversión a ""
              idaccountingline: '0',
              idaccountingcategory: '0',
              idaccountingsubcategory: '0',
              itemconversionfactor: '0',
              itemunitspackaging: '0',
              salesUnits: 1,
              id_account: null,
              isexempt: 0,
              ishidrocarburo: 0,
              turismoporalojamiento: 0,
              barCodes: [{ BarCode: product.code }] // Enviar el código de barras para que el backend lo cree automáticamente
            };

            // Solo agregar campos opcionales si tienen valores
            if (product.family) newProductData.family = product.family;
            if (product.category) newProductData.category = product.category;
            if (product.subcategory) newProductData.subcategory = product.subcategory;
            if (product.brand) newProductData.items_brand = product.brand;

            console.log('Creando producto:', newProductData);

            // Crear producto usando FormData
            const formdata = new FormData();
            formdata.append("product", JSON.stringify(newProductData));
            formdata.append("providers", JSON.stringify([{ ID_Provider: this.data.ID_Provider }]));

            const response = await this.$API.products.addProduct(formdata);
            if (response && response.externalStoreSyncWarning) {
              unconfirmedCount++;
              syncWarning = response.externalStoreSyncWarning;
            }
            
            // El backend devuelve data.ID_Item, no id
            if (response && response.data && response.data.ID_Item) {
              // Actualizar el producto en la lista como vinculado
              const index = this.productsToLoad.findIndex(p => p.code === product.code);
              if (index !== -1) {
                const updatedProduct = {
                  ...this.productsToLoad[index],
                  id: response.data.ID_Item,
                  error: { code: false, message: 'Producto creado y vinculado exitosamente' }
                };
                this.$set(this.productsToLoad, index, updatedProduct);
              }

              createdCount++;
            }
          } catch (error) {
            console.error('Error creando producto:', product.code, error);
            errorCount++;
          }
        }

        // Mostrar resultado
        if (errorCount === 0) {
          this.showAlert(
            unconfirmedCount ? 'warning' : 'success',
            'Productos creados exitosamente',
            `Se crearon ${createdCount} producto(s) correctamente.${unconfirmedCount ? ` ${unconfirmedCount} producto(s) sin confirmación: ${syncWarning}` : ''}`
          );
        } else {
          this.showAlert(
            'warning',
            'Productos creados parcialmente',
            `Se crearon ${createdCount} producto(s). ${errorCount} producto(s) no se pudieron crear.${unconfirmedCount ? ` ${unconfirmedCount} producto(s) sin confirmación: ${syncWarning}` : ''}`
          );
        }

        // Recargar productos del proveedor
        if (this.data.ID_Provider) {
          this.getAllBarCodes(this.data.ID_Provider);
        }
        
      } catch (error) {
        this.showAlert(
          'danger',
          'Error al crear productos',
          error.message
        );
      }
    },

    clearJsonData() {
      this.currentImportSource = null;
      this.pendingExcelSkippedRows = [];
      this.jsonData = null;
      this.selectedFile = null;
      this.selectedProduct = null;
      this.productsToLoad = [];
      this.jsonProcessing = false;
      this.showJsonLoading = false;
    },
    
    // Fin funciones JSON
    async getInfoBranch() {
      let idbusiness =
        JSON.parse(localStorage.getItem("user")).businessid || "";
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
      this.$API.branches
        .findSpecificBranch({ branch: idbranch, business: idbusiness })
        .then((res) => {
          const infobusiness = res[0];
          this.datatoprint.branch.AuthFeMode = infobusiness.AuthFeMode;
          this.datatoprint.branch.BusinessBillingNRC =
            infobusiness.BusinessBillingNRC;
          this.datatoprint.branch.BusinessBillingNIT =
            infobusiness.BusinessBillingNIT;
          this.datatoprint.branch.BusinessBillingName =
            infobusiness.BusinessBillingName;
          this.taxPayerSize = infobusiness.BusinessTaxPayerSize;
          this.BusinessLegalAgentRetain = infobusiness.LegalAgentRetain;
        });
    },
    filterPromise(filterObj) {
      const filterArray = [
        "ID_Item",
        "ItemName",
        "Warehouse",
        "ID_ItemBatch",
        "iva",
        "ItemNewPrice",
        "ItemPriceQty",
        "qty",
        "ExpirationDate",
      ];

      return new Promise((resolve, reject) => {
        try {
          resolve(
            multipleCriteriaFilter(filterArray, filterObj, this.productsToShow)
          );
        } catch (error) {
          reject(error);
        }
      });
    },
    async getAllWarehouses() {
      let idbusiness =
        JSON.parse(localStorage.getItem("user")).businessid || "";
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
      let filterWarehouses = {};
      filterWarehouses.branch = idbranch;
      filterWarehouses.business = idbusiness;
      this.$API.warehouse.getWarehouses(filterWarehouses).then((response) => {
        this.warehouses = response;

        let found = this.warehouses.find((wh) => wh.Active == true && wh.ID_Branch == idbranch)

        if (found) {
          this.globalWarehouse = found.ID_Warehouse
        }

        if (this.detailsToshow) this.payloadEditOrderDetails(response);
      });
    },
    addproductsby() {
      const selectedProduct = this.currentIembyname?.data || this.currentIembyname;
      const selectedProductById = this.currentIembyId?.data || this.currentIembyId;

      if (selectedProduct != null) {
        this.addProduct(selectedProduct);
      }
      if (selectedProductById != null) {
        this.addProduct(selectedProductById);
      }

      this.currentIembyname = null;
      this.currentIembyId = null;
      this.clearProductNameSearch();
    },
    addservicesby() {
      if (this.currentItemServiceByName != null) {
        this.addService(this.currentItemServiceByName);
        this.currentItemServiceByName = null;
      }
      if (this.currentItemServiceById != null) {
        this.addService(this.currentItemServiceById);
        this.currentItemServiceById = null;
      }
    },
    statusAlert(val){
      this.doc_alert.show = false;
      if (this.doc_alert.resolve) {
        this.doc_alert.resolve(val);
        this.doc_alert.resolve = null;
      }
    },
    showAlertDoc(
      type = "questionDanger", 
      header = "Proveedor incorrecto", 
      body = "El archivo JSON no corresponde al proveedor, ¿Desea continuar de todas formas?"
    ){
      return new Promise((resolve) => {
          this.doc_alert.resolve = resolve;
          this.doc_alert = {
            type,
            header,
            body,
            show: true,
            status: false,
            resolve
          };
        });
    },
    closeAlert() {
      if (this.alert.onCancel) {
        this.alert.onCancel();
      }

      this.alert.show = false;
      this.alert.onCancel = null;
      this.alert.onAccept = null;

      if (this.alert.options == "insert") {
        this.$store.dispatch("reloadData", "purchase");
        this.$store.commit("providersData/setOrderDetails", null);
        this.$store.commit("providersData/setOrder", null);
        this.$store.commit("providersData/setReloaders", "reloadAddPurchase");

        this.$store.commit("providersData/changeView", "tab-3");
      }

      if (this.alert.options == "updateFinishAndPrintInvoice") {
        this.print2 = {
          show: true,
          data: { ...this.datatoprint },
          closeCallback: () => {
            this.$store.commit("posData/setReloaders", "reloadHistory");
          },
        };

        this.productsToShow = []
      }

      this.alert.options = null;
    },
    acceptAlert() {
      if (this.alert.onAccept) {
        this.alert.onAccept()
      }
      this.alert.show = false;
      this.alert.onAccept = null;
      this.alert.onCancel = null;
      this.alert.options = null;
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    getProducts() {
      console.warn('GetProducts');
      
      this.loadingProducts = true;
      this.productsToBill =[];
      this.$API.products
        .getProductsToBillForPurchaseOrders({
          filterProducts: this.filterProducts,
        })
        .then((response) => {
          //console.log("productos", response);
          this.productsToBill = response;
        })
        .catch((error) => {
          console.log('Busqueda de productos, Error:',error);
        })
        .finally(()=> this.loadingProducts = false);
    },
    getAllServices() {
      this.$API.services
        .getAllServicesHistory()
        .then((response) => {
          this.servicesToBill = response;
        })
        .catch((error) => {
          console.log("error de servicios");
          console.log(error);
        })
    },
    setNewItem(data) {
      let item = null;

      if (this.displayInvoice === 'products') {
        let dataCopy = {...data}
        let ItemPriceQty = 0;

        if(this.globalWarehouse != null && this.globalWarehouse != '') {
          let found = this.warehouses.find((wh) => wh.ID_Warehouse == this.globalWarehouse)
          dataCopy.Warehouse = found.Warehouse
          dataCopy.ID_Warehouse = found.ID_Warehouse
        }

        item = {
          ...dataCopy,
          ItemNewPrice: parseFloat(parseFloat(dataCopy.AverageCost).toFixed(4)),
          qty: 0,
          cotrans: 0,
          fovial: 0,
          ItemPriceQty: ItemPriceQty,
          IsExento: false,
          IsNoSujeto: false,
          iva: (this.header.purchaseordertype == 'CCF' || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? true : false,
        }
      } else  if (this.displayInvoice === 'services') { 
        let ItemPriceQty = 0;

        item = {
          AditionalType: null,
          ID: null,
          ID_AccountingCategory: null,
          ID_AccountingLine: null,
          ID_AccountingSubCategory: null,
          ID_Branch: data.ID_Branch,
          ID_Business: data.ID_Business,
          ID_Item: data.CodeService,
          ID_Provider: this.data.ID_Provider,
          ID_Warehouse: null,
          IdAccountingFamily: null,
          IsGlobalBranch: data.IsGlobalBranch,
          ItemBarCode: null,
          ItemComercialName: data.Name || data.NameService,
          ItemConversionFactor: null,
          ItemDescription: data.Name || data.NameService,
          ItemImagePath: null,
          ItemLote: null,
          ItemMeasureUnit: null,
          ItemName: data.Name || data.NameService,
          ItemNote: "",
          ItemPrice: data.Price,
          ItemType: "service",
          SystemDateInsert: data.SystemDateInsert,
          UnitsPackaging: null,
          Warehouse: null,
          ItemNewPrice: 0,
          qty: 0,
          ItemPriceQty: ItemPriceQty,
          IsExento: false,
          IsNoSujeto: false,
        }
      }

      this.newItem = item;
      this.$nextTick(() => {
        const qtyField = this.$refs.newItemQty;
        if (qtyField && typeof qtyField.focus === 'function') {
          qtyField.focus();
          return;
        }

        const input = qtyField?.$el?.querySelector('input');
        if (input) {
          input.focus();
          input.select?.();
        }
      });
    },

    addNewItem() {
      if (isNaN(this.newItem.ItemNewPrice)) {
        this.newItem.ItemNewPrice = 0;
        this.newItem.price =  0.0;
        this.newItem.noGlobalDicountPrice = this.newItem.price;
      } else {
        this.newItem.price = parseFloat(this.newItem.ItemNewPrice) || 0.0;
        this.newItem.price = parseFloat(this.newItem.price.toFixed(4)) || 0.0;
        this.newItem.noGlobalDicountPrice = this.newItem.price;
        this.newItem.ItemNewPrice = this.newItem.price;
      }

      if (isNaN(this.newItem.qty)) {
        this.newItem.qty = 0;
      }

      if (this.displayInvoice === 'products' && !this.newItem.ID_ItemBatch) {
        this.newItem.ID_ItemBatch = '';
      }

      this.productsToShow.push(this.newItem);
      this.newItem = null;
    },

    addProduct(data) {
      //if (!this.productsToShow.find((i) => i.ID_Item == data.ID_Item)) {
        let dataCopy = {...data}
        let ItemPriceQty = 0;
        if(this.globalWarehouse != null && this.globalWarehouse != '') {
          let found = this.warehouses.find((wh) => wh.ID_Warehouse == this.globalWarehouse)
          dataCopy.Warehouse = found.Warehouse
          dataCopy.ID_Warehouse = found.ID_Warehouse
        }

        const price = parseFloat(dataCopy.AverageCost) || 0.0;

        this.productsToShow.push({
          ...dataCopy,
          price,
          noGlobalDicountPrice: price,
          ItemNewPrice: parseFloat(price.toFixed(4)),
          qty: 0,
          cotrans: 0,
          fovial: 0,
          ItemPriceQty: ItemPriceQty,
          IsExento: false,
          IsNoSujeto: false,
          iva: (this.header.purchaseordertype == 'CCF' || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? true : false,
        });
      //}
    },

    addService(data) {
      //if (!this.productsToShow.find((i) => i.ID_Item == data.CodeService)) {
        let ItemPriceQty = 0;
        this.productsToShow.push({
          AditionalType: null,
          ID: null,
          ID_AccountingCategory: null,
          ID_AccountingLine: null,
          ID_AccountingSubCategory: null,
          ID_Branch: data.ID_Branch,
          ID_Business: data.ID_Business,
          ID_Item: data.CodeService,
          ID_Provider: this.data.ID_Provider,
          ID_Warehouse: null,
          IdAccountingFamily: null,
          IsGlobalBranch: data.IsGlobalBranch,
          ItemBarCode: null,
          ItemComercialName: data.Name || data.NameService,
          ItemConversionFactor: null,
          ItemDescription: data.Name || data.NameService,
          ItemImagePath: null,
          ItemLote: null,
          ItemMeasureUnit: null,
          ItemName: data.Name || data.NameService,
          ItemNote: "",
          ItemPrice: data.Price,
          price: parseFloat(data.Price) || 0.0,
          noGlobalDicountPrice: parseFloat(data.Price) || 0.0,
          ItemType: "service",
          SystemDateInsert: data.SystemDateInsert,
          UnitsPackaging: null,
          Warehouse: null,
          ItemNewPrice: 0,
          qty: 0,
          ItemPriceQty: ItemPriceQty,
          IsExento: false,
          IsNoSujeto: false,
        })
      //}
    },

    removeRow(data) {
      const realIndex = this.productsToShow.findIndex(item => item.ID_Item === data.data.ID_Item);
      if (realIndex !== -1) {
        this.productsToShow.splice(realIndex, 1);
      }
      if (this.globalDiscount) {
        this.applyGlobalDiscount()
      }
    },
    Preview_image() {
      this.url = this.image ? URL.createObjectURL(this.image) : "";
    },
    async getPurchaseId() {
      await this.$API.orders.getOrderId().then((response) => {
        this.orderid = response;
        this.header.orderid = response;
      });
    },
    resetData() {
      this.$store.commit("providersData/setOrderDetails", null);
      this.$store.commit("providersData/setOrder", null);
      this.$store.commit("providersData/setReloaders", "reloadAddPurchase");
    },
    async validateCorrelative(statusPurchaseOrde) {
      try {
        this.loading = true
        await this.getOrderList();
        const providerId = this.data.ID_Provider;
        const documentType = this.header.documenttype;
        const correlativeId = this.header.purchaselegalinvoicenumber;

        const found = this.orderList.filter((item) => {
          const sameItem = this.header.orderid === item.ID_PurchaseOrder

          if (!sameItem && item.ID_PurchaseLegalInvoiceNumber === correlativeId) {
            if (documentType === '2') {
              return true;
            } else {
              if (item.ID_Provider === providerId) {
                return true;
              }
            }
          }

          return false;
        })

        let addPurchaseCallback = 
          statusPurchaseOrde === 'process' && this.header.purchaseordertype === 'FNS'
            ? () => this.addFnsPurchaseOrder()
            : () => this.addPurchaseOrder(statusPurchaseOrde)

        if (found.length > 0) {
          this.alert.onAccept = addPurchaseCallback;

          const codeName = documentType === '1' ? 'correlativo' : 'código de generación';

          const alertMessage = statusPurchaseOrde === 'process' 
            ? `Ya existe una orden de compra registrada con el ${codeName} ingresado. ¿Desea continuar y procesar la orden?`
            : `Ya existe una orden de compra registrada con el ${codeName} ingresado. ¿Desea continuar y guardar la orden?`;


          this.showAlert(
            "question2",
            "Advertencia",
            alertMessage
          );
        } else {
          addPurchaseCallback()
        }
        this.loading = false
      } catch (err) {
        console.log(err)
        this.showAlert(
          "warning",
          "Advertencia",
          "Se produjo un error validando el correlativo."
        );
        this.loading = false
      }    
    },
    async addPurchaseOrder(statusPurchaseOrde) {
      try {
        if (this.checkImageSize()) return;
  
        //find a number negative o nan
        let negative = false;
        this.productsToShow.forEach((element) => {
          if (
            element.qty <= 0 ||
            element.qty == null ||
            element.qty == undefined
          ) {
            negative = true;
          }
        });
        if (negative) {
          this.showAlert(
            "warning",
            "Advertencia",
            "La cantidad de los productos no puede ser menor o igual a 0"
          );
          return;
        }

        if (!this.validateRequiredExpirationDates()) return;
  
        statusPurchaseOrde == "notprocess"
          ? (this.header.purchaseorderpendingpayment = true)
          : (this.header.purchaseorderpendingpayment = false);
        statusPurchaseOrde == "process"
          ? (this.header.orderprocessed = true)
          : (this.header.orderprocessed = false);
  
        let errors = 0;
  
        if (statusPurchaseOrde == "process") {
          this.header.purchaselegalinvoicenumber == "No hay correlativo" ||
          this.header.purchaselegalinvoicenumber == ""
            ? (errors += 1)
            : "";
  
          this.header.paymentMethod ? "" : (errors += 1);
          this.header.invoiceStatus ? "" : (errors += 1);
          this.header.documenttype ? "" : (errors += 1);
  
          if (this.header.invoiceStatus == "Crédito") {
            this.header.days ? "" : (errors += 1);
          } else {
            this.header.days = null;
          }
          const itemWithOutWarehouse = this.isAllItemsWhitOutWarehouse(this.productsToShow)
          if (itemWithOutWarehouse){
            this.showAlert(
            "warning",
            "Advertencia",
             `El articulo "${itemWithOutWarehouse.ItemName}" con id "${itemWithOutWarehouse.ID_Item}" no tiene una bodega/almacén asignado.`
          );
          return;
          }
        }

        if( this.header.CustomCSVPeriodFlag ) {
          this.submitCustomCSVPeriodState = true;
          !this.header.CustomCSVPeriodMonth && ( errors += 1 );
          !this.header.CustomCSVPeriodYear && ( errors += 1 );
        }
  
        if (errors > 0) {
          this.showAlert(
            "warning",
            "Advertencia",
            "Debe llenar todos los campos obligatorios"
          );
          return;
        }
        this.loading = true;

        let ivaGeneral = 0.00;

        if (this.header.purchaseordertype != 'CCF' && this.header.purchaseordertype != 'NC' && this.header.purchaseordertype != 'ND' && this.header.purchaseordertype != 'FI' && this.header.purchaseordertype != 'DDM') {
          ivaGeneral = parseFloat(parseFloat(this.sumObject.subTotal) - (parseFloat(this.sumObject.subTotal) / 1.13)).toFixed(4)
        }
        else {
          ivaGeneral = parseFloat(this.sumObject.iva).toFixed(4)
        }
  
        let header = {
          ...this.header,
          subtotal: (this.header.purchaseordertype != "CCF" && this.header.purchaseordertype != 'NC' && this.header.purchaseordertype != 'ND' && this.header.purchaseordertype != 'FI' && this.header.purchaseordertype != 'DDM') ? ( (this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? (parseFloat(this.sumObject.subTotal / (1 + (parseFloat(this.percentIvaFi)/100)) ).toFixed(4)) : (parseFloat(this.sumObject.subTotal / 1.13).toFixed(4)) ) : parseFloat(this.sumObject.subTotal).toFixed(4),
          iva: ivaGeneral,
          incometax: this.sumObject.nontaxable,
          ivaret: parseFloat(this.sumObject.ivaret).toFixed(4),
          total: parseFloat(this.sumObject.total).toFixed(4),
          purchaselegalinvoicenumber: this.header.purchaselegalinvoicenumber,
          CustomCSVPeriodFlag: this.header.CustomCSVPeriodFlag,
          CustomCSVPeriodMonth: this.header.CustomCSVPeriodMonth,
          CustomCSVPeriodYear: this.header.CustomCSVPeriodYear,
          ClasificationRent: this.header.ClasificationRent,
          numerocontrol: this.header.numerocontrol || null,
          NumeroDocumentoRelacionado: this.header.NumeroDocumentoRelacionado || null,
          selloRecibido: this.header.selloRecibido || null,
          purchaseorderimage: this.url,
          ivaperc: parseFloat(this.sumObject.ivaperc).toFixed(4),
          exento: parseFloat(this.sumObject.exento).toFixed(4),
          nosujeto: parseFloat(this.sumObject.nosujeto).toFixed(4),
          reterenta: parseFloat(this.sumObject.reterenta).toFixed(4),
          fovial: parseFloat(this.sumObject.fovial).toFixed(4),
          cotrans: parseFloat(this.sumObject.cotrans).toFixed(4),
        };
  
        let items = this.productsToShow.map((i) => {
          let total_price = parseFloat(i.ItemNewPrice) * parseFloat(i.qty);
          let unitPrice = parseFloat(i.ItemNewPrice)
          let totalUnitIva = (this.header.purchaseordertype == "CCF" || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? ( (this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? (parseFloat(unitPrice * (parseFloat(this.percentIvaFi) / 100))) : (parseFloat(unitPrice * 0.13)) ) : parseFloat(unitPrice - (unitPrice / 1.13))
          let totalUnitCost = (this.header.purchaseordertype == "CCF" || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? parseFloat(unitPrice) : parseFloat(unitPrice / 1.13)
          let totalIva = (this.header.purchaseordertype == "CCF" || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? ( (this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? (parseFloat(total_price * (parseFloat(this.percentIvaFi) / 100))) : (parseFloat(total_price * 0.13)) ) : parseFloat(total_price - (total_price / 1.13))
          let totalCCF = parseFloat(total_price + totalIva)

          return {
            Pk_inventory_purchase_order_details: i.Pk_inventory_purchase_order_details || null,
            itemquantity: i.qty,
            iditem: i.ID_Item,
            itemcurrency: i.ItemCurrency || "$",
            itemunitcost: (this.header.purchaseordertype == "CCF" || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? parseFloat(i.ItemNewPrice).toFixed(4) : parseFloat(totalUnitCost).toFixed(4),
            itemincometax: 0, //Esto es inservible - i.nontaxable ? parseFloat(total_price).toFixed(4) : 0,
            itemiva: (i.IsExento || i.IsNoSujeto) ? 0 : parseFloat(totalUnitIva).toFixed(4),
            itemrettax: 0, //Esto es inservible - parseFloat(ivaret).toFixed(4),
            itemtotalcost: (i.IsExento == false && i.IsNoSujeto == false) ?
              ( (this.header.purchaseordertype == "CCF" || this.header.purchaseordertype == 'NC' || this.header.purchaseordertype == 'ND' || this.header.purchaseordertype == 'FI' || this.header.purchaseordertype == 'DDM') ? parseFloat(totalCCF).toFixed(4) : parseFloat(total_price).toFixed(4) )
              : 0,
            itemtype: i.ItemType,
            warehouse: i.ID_Warehouse,
            expirationdate: i.ExpirationDate || "",
            iditembatch: i.ID_ItemBatch || "",
            idbranch: header.idbranch,
            isglobalbranch: i.IsGlobalBranch,
            idbusiness: i.ID_Business,
            itemmeasureunit: i.ItemMeasureUnit,
            barcode: i.BarCode,
            itemexento: i.IsExento ? parseFloat(total_price ).toFixed(4) : 0,
            itemnosujeto: i.IsNoSujeto ? parseFloat(total_price ).toFixed(4) : 0,
            
          };
        });
  
        const formdata = new FormData();
        
        formdata.append("file", this.image);
        formdata.append("header", JSON.stringify(header));
        formdata.append("items", JSON.stringify(items));
        this.$API.orders
          .addOrder(formdata)
          .then((response) => {
            this.loading = false;
            const warning = response && response.externalStoreSyncWarning;
            this.showAlert(
              warning ? "warning" : "success",
              "Orden de compra",
              warning ? response.message + " " + warning : response.message,
              "insert"
            );
            
            this.$store.commit("setChanguePriceList", true);
          })
          .catch((error) => {
            this.loading = false;
            this.showAlert(
              "danger",
              "Orden de compra",
              error?.message || "Error al crear la orden de compra"
            );
          });
      } catch (error) {
        this.loading = false;
        this.showAlert(
          "danger",
          "Orden de compra",
          error?.message || "Error al crear la orden de compra"
        );
      }
    },

    isAllItemsWhitOutWarehouse(items) {
      return items.find(item => item.ItemType != "service" && (!item.ID_Warehouse || item.ID_Warehouse === '' || item.ID_Warehouse === undefined));
    },

    async addFnsPurchaseOrder() {
      const userStorage = JSON.parse(localStorage.getItem("user") || "{}");
      const branchStorage = JSON.parse(localStorage.getItem("branch") || "{}");
      const normalizeCodPointSale = (value) => {
        const raw = String(value ?? "").trim();
        const digits = raw.replace(/\D/g, "");
        const numeric = digits ? parseInt(digits, 10) : 1;
        return `P${String(Number.isNaN(numeric) ? 1 : numeric).padStart(3, "0")}`;
      };
      const branchPointSale =
        branchStorage.codpuntoventa ||
        branchStorage.CodPuntoVenta ||
        branchStorage.codpuntoventamh ||
        branchStorage.CodPuntoVentaMH ||
        null;
      const codPointSale =
        userStorage.pointsale ||
        branchPointSale ||
        1;
      const formattedCodPointSale = normalizeCodPointSale(codPointSale);
      
      const ambiente =
        Number(branchStorage.AuthFeMode ?? branchStorage.authfemode ?? 0) === 1
          ? "01"
          : "00";
      const tipoDte =
        this.catalogTypedocument.find(
          ({ value }) => value === this.header.purchaseordertype
        )?.code ||
        (this.header.purchaseordertype === "FNS" ? "14" : null);

      if (
        this.header.paymentMethod == undefined ||
        this.header.paymentMethod == null ||
        this.header.paymentMethod == ""
      ) {
        this.showAlert(
          "warning",
          "Advertencia",
          "El método de pago de la factura del proveedor es requerido."
        );
        return;
      }

      if (!this.validateRequiredExpirationDates()) return;

      let header = {
        ...this.header,
        subtotal: parseFloat(this.sumObject.subTotal).toFixed(4),
        iva: parseFloat(this.sumObject.iva).toFixed(4),
        incometax: this.sumObject.nontaxable,
        ivaret: parseFloat(this.sumObject.ivaret).toFixed(4),
        total: parseFloat(this.sumObject.total).toFixed(4),
        purchaselegalinvoicenumber: this.header.purchaselegalinvoicenumber,
        numerocontrol: this.header.numerocontrol || null,
        selloRecibido: this.header.selloRecibido || null,
        purchaseorderimage: this.url,
        exento: parseFloat(this.sumObject.exento).toFixed(4),
        nosujeto: parseFloat(this.sumObject.nosujeto).toFixed(4),
        reterenta: parseFloat(this.sumObject.reterenta).toFixed(4),
        fovial: parseFloat(this.sumObject.fovial).toFixed(4),
        cotrans: parseFloat(this.sumObject.cotrans).toFixed(4),
      };

      let obj = {
        invoicedate: header.purchaseorderdate,
        invoicetype: header.purchaseordertype,
        idinvoice: null,
        invoiceidinvoice: "No hay correlativo",
        invoiceisnontaxable:
          header.purchaseorderisnontaxable == "" ||
          header.purchaseorderisnontaxable == null
            ? 0
            : 1,
        invoiceisnonsuj: 0,
        istemplate: 0,
        isquote: 0,
        timesexecute: 0,
        idbusiness: header.idbusiness || userStorage.businessid || "",
        idbranch: header.idbranch || userStorage.branch || "",
        idcustomer: header.provider,
        firstname: null,
        lastname: null,
        phonenumber: null,
        mobilenumber: null,
        email: null,
        gender: null,
        age: null,
        dateofbirth: null,
        address: null,
        city: header.purchaseordercity,
        state: header.purchaseorderstate,
        country: header.purchaseordercountry,
        notes: header.purchaseordernotes,
        status: 1,
        sendemail: 0,
        sendsms: 0,
        sendwhatsapp: 0,
        sendpushup: 0,
        isa_business: true,
        businessname: header.purchaseordername,
        businessphone: header.purchaseorderphone,
        businessmobilenumber: header.purchaseordermobile,
        businessemail: header.purchaseorderemail,
        businesscontactname: header.purchaseordercontactname,
        businesscontactphone: header.purchaseordercontactphone,
        businesscontactmobile: header.purchaseordercontactmobile,
        businesscontactemail: header.purchaseordercontactemail,
        businesswebsite: null,
        sendemailbusinessemail: 0,
        sendsmsbusinessmobile: 0,
        sendwhatsappbusinessmobile: 0,
        invoicename: header.purchaseordername,
        invoiceaddress: header.purchaseorderaddress,
        invoicenrc: header.purchaseordernrc,
        invoicenit: header.purchaseordernit,
        dui: null,
        invoicesector: header.purchaseordersector,
        invoiceentity: header.purchaseorderentity,
        invoicetaxpayersize: header.purchaseordertaxpayersize,
        invoiceinfo: null,
        iduser_insert: null,
        iduser_update: null,
        department: header.purchaseorderstate,
        municipality: header.purchaseordercity,
        codactividad: null,
        descactividad: null,
        iddocumenttype: 2,
        prefijo: null,
        pricelistname: null,
        limitcredit: 0,
        itemtext: header.purchaseordername,
        invoicepaymenttype: header.paymentMethod,
        invoicestatusdescription: header.invoiceStatus,
        invoicecreditday: header.days,
        invoicestatus: 1,
        invoicedescunosuj: 0,
        invoicedescuexenta: 0,
        invoicedescugravada: 0,
        invoiceporcentajedescuento: 0,
        invoicetotaldescu: 0,
        invoicesubtotalventas: parseFloat(
          parseFloat(header.subtotal).toFixed(2)
        ),
        invoicesubtotal: parseFloat(parseFloat(header.subtotal).toFixed(2)),
        invoicemontototaloperacion: parseFloat(
          parseFloat(header.subtotal).toFixed(2)
        ),
        invoicetotalexenta: header.exento,
        invoicetotalnosuj: header.nosujeto,
        invoicetotalgravada: parseFloat(parseFloat(header.subtotal).toFixed(2)),
        invoicetotalpagar: parseFloat(parseFloat(header.total).toFixed(2)),
        invoicetotaliva: 0,
        invoiceivarete1: 0,
        invoiceivaperce1: 0,
        invoicetotalletras: numberToText(header.total),
        invoicedui: null,
        invoicereterenta: parseFloat(parseFloat(header.reterenta).toFixed(2)),
        codpointsale: codPointSale,
        codpointsaleInv: formattedCodPointSale,
        ambiente: ambiente,
        tipoDte: tipoDte,
        codestablemh: branchStorage.codestablemh || branchStorage.CodEstableMH || null,
        clasificationrent: header.ClasificationRent || null,
        tipoingresoproveedores: header.TipoIngresoProveedores || null,
        sectorproveedores: header.SectorProveedores || null,
      };

      let payment = {};
      payment.typePayment = this.paymentTypes.find(
        (element) => element.Valores === this.header.paymentMethod
      ).Codigo;
      payment.descriptionPayment = this.header.paymentMethod;
      payment.totalPayment = obj.invoicetotalpagar;
      if (
        this.header.paymentMethod != "Billetes y monedas" &&
        this.header.nreference != undefined
      ) {
        payment.reference = this.header.nreference;
      } else {
        payment.reference = null;
      }

      let payments = [];
      payments.push(payment);

      obj.payments = payments;

      let items = this.productsToShow.map((i) => {
        let total_price = parseFloat(i.ItemNewPrice) * parseFloat(i.qty);
        let iva = parseFloat(total_price - total_price / 1.13);
        //let ivaret = 0;

        return {
          idbranch: i.ID_Branch,
          idbusiness: i.ID_Business,
          iditem: i.ID_Item,
          itemtype: i.ItemType,
          itemquantity: i.qty,
          itemmeasureunit: i.ItemMeasureUnit,
          itemdescription: i.ItemName,
          itemunitcost: parseFloat(parseFloat(i.ItemNewPrice).toFixed(8)),
          itemdiscount: 0,
          itemdiscountpercent: 0,
          itemnosuj: i.IsExento ? parseFloat(total_price).toFixed(8) : 0,
          itemexenta: i.IsNoSujeto ? parseFloat(total_price).toFixed(8) : 0,
          itemgravada: (i.IsExento == false && i.IsNoSujeto == false) ? parseFloat(parseFloat(total_price).toFixed(8)) : 0,
          itempsv: 30,
          itemnogravada: 0,
          itemiva: (i.IsExento || i.IsNoSujeto) ? 0 : iva,
          itemcurrency: i.ItemCurrency || "$",
          expirationdate: i.ExpirationDate || "",
          itembatch: i.ID_ItemBatch || "",
          warehouse: i.ID_Warehouse,
          barcode: i.BarCode || "",
        };
      });
      this.loading = true;

      this.$API.invoices
        .addInvoice({
          header: obj,
          items: items,
          user: JSON.parse(localStorage.getItem("user")).id,
          invalid: null,
          ndornc: null,
        })
        .then(async (response) => {
          this.loading = false;

          this.datatoprint.dteJson = response.billingDteJsonHeader;
          if (response.estado == "PROCESADO") {
            let mensaje = "";
            mensaje = "Se ha realizado y procesado la factura.<br/><br/>";
            mensaje += "Estado: " + response.estado + "<br/>";
            mensaje +=
              "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
            mensaje += "Observaciones DTE: <br/>";
            if (response.observaciones.length == 0) {
              mensaje += "- Ninguna observación <br/>";
            } else {
              for (let i = 0; i < response.observaciones.length; i++) {
                mensaje += "- " + response.observaciones[i] + "<br/>";
              }
            }

            this.datatoprint.header = await this.$API.invoices.getInvoice(
              response.billingDteJsonHeader.ID_Invoice
            );
            this.datatoprint.body = await this.$API.invoices.getAllInvoiceItems(
              response.billingDteJsonHeader.ID_Invoice
            );
            //console.log("VEAMOS", this.datatoprint)
            this.showAlert(
              "successHtml",
              "Factura generada",
              mensaje,
              "updateFinishAndPrintInvoice"
            );
          } else if (response.estado == "CONTINGENCIA") {
            let mensaje = "";
            mensaje = `La factura se ha guardado en estado de contingencia.<br/><br/>`;
            mensaje += "Estado: " + response.estado + "<br/>";
            mensaje +=
              "Error del DTE: <br/> - " +
              response.status +
              ", " +
              response.error +
              "<br/>";
            this.datatoprint.header = await this.$API.invoices.getInvoice(
              response.billingDteJsonHeader.ID_Invoice
            );
            this.datatoprint.body = await this.$API.invoices.getAllInvoiceItems(
              response.billingDteJsonHeader.ID_Invoice
            );
            this.showAlert(
              "successHtml",
              "Factura generada",
              mensaje,
              "updateFinishAndPrintInvoice"
            );
          } else {
            let mensaje =
              "Se ha rechazado la factura, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.<br/><br/>";
            mensaje += "Estado: " + response.estado + "<br/>";
            mensaje +=
              "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
            mensaje += "Observaciones DTE: <br/>";
            if (response.observaciones.length == 0) {
              mensaje += "- Ninguna observación <br/>";
            } else {
              for (let i = 0; i < response.observaciones.length; i++) {
                mensaje += "- " + response.observaciones[i] + "<br/>";
              }
            }
            this.showAlert("successHtml", "Factura rechazada", mensaje);
          }
        });
    },

    onEditorChange(e) {
      this.header.purchaseorderinternalnote = e.html;
      if (this.header.purchaseorderinternalnote != "") {
        this.showBgcolorNotes = "tabsContent";
      } else if (
        this.header.purchaseorderinternalnote == "" ||
        this.header.purchaseorderinternalnote == "<p><br></p>"
      ) {
        this.showBgcolorNotes = "tabs";
      } else {
        this.showBgcolorNotes = "tabs";
      }
    },

    async payloadEditOrderDetails(warh) {
      let product = [];

      this.orderDetails.forEach((element) => {
        
        for (let i = 0; i < warh.length; i++) {
          if (warh[i].ID_Warehouse == element.Warehouse) {
            element.WarehouseName = warh[i].Warehouse;
          }
        }

        const scale = 10000;

        // round to 4 decimal places
        
        let ItemNewPrice = 0.0

        const orderType = this.order["PurchaseOrderType"]

        if (orderType == 'CCF' 
          || orderType == 'NC' 
          || orderType == 'ND') {
          ItemNewPrice = Math.round(element.ItemUnitCost * scale) / scale;
        } else {
          ItemNewPrice = (Math.round(element.ItemUnitCost * scale) + Math.round(element.ItemIVA * scale)) / scale
        }

        let item = {
          Pk_inventory_purchase_order_details: element.Pk_inventory_purchase_order_details,
          ItemNewPrice,
          qty: element.ItemQuantity,
          ID_Item: element.ID_Item,
          ItemCurrency: element.ItemCurrency,
          nontaxable: element.ItemIncomeTax,
          ItemType: element.ItemItemType,
          ID_Warehouse: element.Warehouse,
          Warehouse: element.WarehouseName,
          ExpirationDate: element.ExpirationDate,
          ID_ItemBatch: element.ID_ItemBatch || element.InvID_ItemBatch,
          ID_Branch: element.ID_Branch,
          IsGlobalBranch: element.IsGlobalBranch,
          ID_Business: element.ID_Business,
          ItemMeasureUnit: element.ItemMeasureUnit,
          ItemPriceQty: element.ItemTotalCost,
          ItemName: element.ItemName,
          BarCode: element.BarCode,
          IsExento: (element.ItemExento > 0) ? true : false,
          IsNoSujeto: (element.ItemNoSujeto > 0) ? true : false,
        };
        product.push(item);
      });

      this.productsToShow = product;

      await Object.keys(this.order).map((el) => {
        if (el == "ID_PurchaseOrder") {
          this.header.orderid = this.order[el];
          this.orderid = this.order[el];
        }

        if (el == "PurchaseOrderImage") {
          this.url = this.order[el];
          this.Preview_image();
        }

        if (el == "PurchaseOrderDate") {
          this.purchaseorderdate = this.order[el];
          this.header.purchaseorderdate = this.order[el];
        }

        if (el == "PurchaseInvoiceDate") {
          this.purchaseinvoicedate = this.order[el];
          this.header.purchaseinvoicedate = this.order[el];
        }

        if (el == "PurchaseOrderType") {
          this.header.purchaseordertype = this.order[el];
        }

        if (el == "ID_PurchaseLegalInvoiceNumber") {
          this.header.purchaselegalinvoicenumber = this.order[el];
        }

        if (el == "PurchaseOrderInternalNote") {
          this.header.purchaseorderinternalnote = this.order[el];
        }

        if (el == "PurchaseOrderSubTotal") {
          this.sumObject.subTotal = this.order[el];
        }

        if (el == "PurchaseOrderTotalIVA") {
          this.sumObject.iva = this.order[el];
        }

        if (el == "PurchaseOrderTotalIncomeTax") {
          this.sumObject.nontaxable = this.order[el];
        }

        if (el == "PurchaseOrderTotal") {
          this.sumObject.total = this.order[el];
        }
      });
    },
    addByBarCode() {
      /*if (
        !this.productsToShow.find(
          (i) => i.ID_Item == this.barCodeToFind.ID_Item
        )
      ) {*/
        if (this.barCodeToFind) {
           let warehouseSelected = this.getWarehouseWithDefault()
          this.productsToShow.push({
            ...this.barCodeToFind,
            ItemNewPrice: parseFloat(parseFloat(this.barCodeToFind.AverageCost).toFixed(4)),
            qty: 0,
            ItemPriceQty: 0,
            IsExento: false,
            IsNoSujeto: false,
            Warehouse: warehouseSelected.Warehouse,
            ID_Warehouse: warehouseSelected.ID_Warehouse
          });
        }
      //}
    },
    handleBarCodEnterKey() {
      this.getBarCode(this.data.ID_Provider, this.selectedBarCode);
    },

    async handleItemCodeEnterKey() {
      try {
        this.loading = true;
        this.productsToBill = await this.searchProducts(this.itemcode);
        console.log({productsToBill: this.productsToBill, 'itemcode': this.itemcode});
        
        //if (!this.productsToShow.find((i) => i.ID_Item == itemcodeValue)) {

          const data = this.productsToBill.find(
            (j) => j.ID_Item === this.itemcode
          );
          console.log(data);
          
          if (data) {
            let warehouseSelected = this.getWarehouseWithDefault()
            this.productsToShow.push({
              ...data,
              ItemNewPrice: parseFloat(parseFloat(data.AverageCost).toFixed(4)),
              qty: 0,
              ItemPriceQty: 0,
              IsExento: false,
              IsNoSujeto: false,
              Warehouse: warehouseSelected.Warehouse,
              ID_Warehouse: warehouseSelected.ID_Warehouse
            });
            this.itemcode = null;
          }else this.showAlert(
          "warning",
          "Producto no encontrado",
          "Verifique el codigo ingresado, no se encontro ningun producto con ese codigo"
        );
      } catch (error) {
        console.warn('EndPoint busqueda de producto, Error:', error)
      }finally{
        this.loading = false;
      }
      //}
    },
    async searchProducts(filter, options = {}) {
      const { replaceList = true } = options;

      if (replaceList) {
        this.productsToBill = [];
      }

      const filterProducts = {
        business: this.filterProducts.business,
        branch: this.filterProducts.branch,
        provider: this.filterProducts.provider,
        noProvider: this.filterProducts.noProvider,
        filter: filter,
        showAllRecords: false 
      }
      return await this.$API.products
        .getProductsToBillForPurchaseOrdersFiltered(filterProducts);
    },
    hasLocalProductNameMatch(query) {
      const normalizedQuery = (query || "").trim().toLowerCase();

      if (!normalizedQuery) {
        return false;
      }

      return (this.productsToBill || []).some((item) => {
        const name = (item.ItemName || item.ItemComercialName || "").toLowerCase();
        return name.includes(normalizedQuery);
      });
    },
    clearProductNameSearch() {
      if (this.productNameSearchTimeout) {
        clearTimeout(this.productNameSearchTimeout);
        this.productNameSearchTimeout = null;
      }

      this.productNameSearchRequestId += 1;
      this.remoteItemsByName = [];
      this.loadingProductNameSearch = false;
      this.productNameSearch = "";
    },
    onProductNameSearchInput(value) {
      const query = (value || "").trim();

      this.productNameSearch = value;

      if (this.productNameSearchTimeout) {
        clearTimeout(this.productNameSearchTimeout);
        this.productNameSearchTimeout = null;
      }

      if (!query) {
        this.remoteItemsByName = [];
        this.loadingProductNameSearch = false;
        return;
      }

      if (query.length < 3) {
        this.remoteItemsByName = [];
        this.loadingProductNameSearch = false;
        return;
      }

      this.productNameSearchTimeout = setTimeout(() => {
        this.searchProductsByNameFallback(query);
      }, 500);
    },
    async searchProductsByNameFallback(query) {
      const requestId = ++this.productNameSearchRequestId;
      this.loadingProductNameSearch = true;

      try {
        const response = await this.searchProducts(query, { replaceList: false });

        if (requestId !== this.productNameSearchRequestId) {
          return;
        }

        this.remoteItemsByName = Array.isArray(response) ? response : [];
      } catch (error) {
        console.warn("Error buscando productos por nombre en el endpoint:", error);
        if (requestId === this.productNameSearchRequestId) {
          this.remoteItemsByName = [];
        }
      } finally {
        if (requestId === this.productNameSearchRequestId) {
          this.loadingProductNameSearch = false;
        }
      }
    },
    handleCheckboxIva(checked) {
      if (checked) {
        this.header.purchaseordertype = 'CCF'
        this.addValidToTypeInvoice(false)
        this.productsToShow.forEach((item) => {
          Vue.set(item, "iva", true);
        });
      } else {
        this.header.purchaseordertype = 'FCF'
        this.addValidToTypeInvoice(false)
        this.productsToShow.forEach((item) => {
          Vue.set(item, "iva", false);
        });
      }
    },
    filterHandlerProducts(response) {
      this.loadingProducts = true;
      this.productsToBill =[];
      try {
        this.productsToBill = response;
      } catch (error) {
        console.warn(error)
      }finally{
      this.loadingProducts = false;
      }
    },
    filterHandlerServices(response) {
      this.servicesToBill = response;
    },
    maxFileSize(event) {
      if (!event) return true

      const allowedSize = 2 * 1024 * 1024; // 2 MB in bytes
      const fileSize = event.size;

      if (fileSize > allowedSize) {
        this.validImageSize = false;
        return `El tamaño del archivo debe ser menor a 2 Mb`;
      }

      this.validImageSize = true;
      return true;
    },
    checkImageSize() {
      if (this.validImageSize == false) {
        this.showAlert(
          "danger",
          "Error",
          "El tamaño de la imagen debe ser menor a 2 Mb"
        );
        return true;
      }
      return false;
    },
    isTaxCredit() {
      return this.header.purchaseordertype == 'CCF' 
        || this.header.purchaseordertype == 'NC' 
        || this.header.purchaseordertype == 'ND' 
        || this.header.purchaseordertype == 'FI' 
        || this.header.purchaseordertype == 'DDM';
    },
    getScreenBreakpoint() {
      const width = window.innerWidth;
      if (width >= 1260) {
        return 'lg';
      } else if (width >= 1024) {
        return 'md';
      } else {
        return 'sm';
      }
    },
    calculateSummaryBoxPosition() {
      const orderItems = this.$refs.orderItems;
      const summary = this.$refs.summary;
      // Bottom of orderItems container relative to document minus summary element height
      const orderItemsRect = orderItems.getBoundingClientRect();
      this.orderItemsBottom = orderItemsRect.bottom + window.scrollY - summary.offsetHeight;
      this.fixedFooterStyle.left = orderItemsRect.left + 'px';
      this.fixedFooterStyle.width = (orderItemsRect.width - 20) + 'px';
      this.handleScroll();
      
    },
    handleScroll() {
      const scrollBottom = window.scrollY + window.innerHeight + 50; // 50px buffer for better UX
      // If scroll bottom is less than orderItems's bottom and screen is large, keep fixed
      this.fixedFooter = scrollBottom < this.orderItemsBottom && this.getScreenBreakpoint() === 'lg';
    },
    async getOrderList() {
      const query = {
        pending: true,
        start: null,
        end: null,
        business: JSON.parse(localStorage.getItem("user")).businessid,
        branch: JSON.parse(localStorage.getItem("user")).branch,
      };

      try {
        this.orderList = await this.$API.orders.getProvidersProductsHistory(query)
      } catch (err) {
        console.log("Error loading orders history")
      }
    },
    setShowInfoPurchaseDialog(show) {
      if (show) {
        // Set defaults if not already set
        if (!this.header.purchaseordertype) {
          this.header.purchaseordertype = this.catalogTypedocument[0]?.value || '';
        }
        if (!this.header.documenttype) {
          this.header.documenttype = this.documentOptions[0]?.value || '';
        }
        if (!this.header.paymentMethod) {
          this.header.paymentMethod = this.paymentTypes[0]?.Valores || '';
        }
        if (!this.header.invoiceStatus) {
          this.header.invoiceStatus = this.invoiceStatus[0] || '';
        }
      }

      this.header = {...this.header}

      this.showInfoPurchase = show;
    }
  },
};
</script>

<style scoped>
.box {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  background-color: white;
  padding: 0.5rem;
  border-radius: 15px;
  margin: 0.5rem;
}

.input-group.mb-3 {
  text-align: center;
}

.input-group-prepend {
  text-align: left;
}

input.form-control {
  background: #d6eaf3;
  border: 1px solid #1976d2;
  text-align: center;
  max-width: 80px;
  height: 30px;
  border-radius: 20px;
}

.filter-btn {
  position: absolute;
  top: 60px;
  left: 30px;
  z-index: 9;
}

.p-relative {
  position: relative;
}

.btnsave {
  background-color: #3498db !important;
  color: white;
}

.btnclean {
  background-color: #f29d35 !important;
  color: white;
  margin: 0;
  padding: 0;
}

.btn-add {
  background-color: #3498db !important;
  color: white;
}

.btn-json {
  background-color: #3498db !important;
  color: white;
}
.btn-json2 {
  background-color: #3498db !important;
  color: white;
  
}

.scroll-bar {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
}

/* width */
.scroll-bar::-webkit-scrollbar {
  width: 10px;
}

.btnblack {
  background-color: rgba(60, 60, 60, 1) !important;
  color: white;
}

/* Track */
.scroll-bar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
.scroll-bar::-webkit-scrollbar-thumb {
  background: #262626;
  border-radius: 10px;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabsContent:hover {
  background-color: #ffb266;
  cursor: pointer;
}

.tabsContent {
  width: 100%;
  padding: 10px;
  background-color: #f29d35;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.custom-select {
  display: inline-block;
  position: relative;
  font-family: Arial;
  font-size: 14px;
  color: #333;
  background-color: #fff;

  width: 100%;
  box-sizing: border-box;
}

.cell-centered {
  display: flex;
  align-items: start;
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.navbar {
  display: flex;
  height: 4.5rem;
  background: #41464c;
  color: white;
  align-self: flex-start;
  z-index: 100;
  position: sticky;
  margin-left: 2.5%;
  margin-right: 2.5%;
  justify-content: space-around;
}

.btnav {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 50%;
}

.btndisable {
  background-color: #41464c !important;
  color: white;
}

@media screen and (max-device-width: 1024px), screen and (max-width: 1024px) {
  .navbar {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    height: 8rem;
    text-align: center;
  }

  .btnav {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .input-group-prepend {
    text-align: center;
  }

  .widthDate .v-input__slot {
    width: 150px;
  }

  .tabs:hover {
    background-color: rgba(80, 80, 80, 1);
    cursor: pointer;
  }
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.v-application .mb-2 {
  margin-right: 10px !important;
}

.v-application .mb-3 {
  margin-right: 50px !important;
}
</style>

<style>
.scroll-fixing-purchase .dx-overlay-content {
  left: -163% !important;
}

.invoiceResponsiveSummary {
  background: #41464c !important;
  color: white;
  bottom: 0;
  visibility: visible;
}

.grid-update {
  overflow-x: auto;
}

.grid-json .dx-datagrid-content .dx-datagrid-table .dx-row > td {
  vertical-align: middle !important; /* Utiliza !important para asegurar que el estilo se aplique */
  height: 50px;
}

.grid-update .dx-datagrid-content .dx-datagrid-table .dx-row > td {
  vertical-align: middle !important; /* Utiliza !important para asegurar que el estilo se aplique */
  height: 50px;
}

.invoiceResponsiveSummary input.form-control, footer.fixed-summary input.form-control {
  max-width: 90%;
  width: 100%;
}

.invoiceResponsiveSummary input.form-control.total-value, footer.fixed-summary input.form-control.total-value {
  font-size: 1.3rem;
  background-color: #00a178;
  color: white;
  font-weight: bold;
  max-width: 90%;
  width: 100%;
}

@media (max-width: 1024px) {
  .invoiceResponsiveSummary input.form-control {
    max-width: 90%;
    min-width: 90%;
    width: 100%;
  }
}

@media (min-width: 1440px) {
  .invoiceResponsiveSummary input.form-control {
    max-width: 90%;
    min-width: 90%;
    width: 100%;
  }
}

@media only screen and (max-width: 1392px) {
  .toHide {
    display: none !important;
  }

}
@media only screen and (max-width: 440px) {
  btn-size{
    font-size: 20px;
  }
}

</style>
